/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../bills/tender';
import '../../common/currency';
import '../../connect/v2/resources/error';
import '../merchant/service';
import '../../omg/model/orders';
import './model';
import '../../connect/v2/common/date';
import '../../connect/v2/catalog/resources/datatypes';
import '../../common/time';
import '../../connect/v2/common/sort';
import '../../common/location';
import '../../agenda/agendasync';
import '../merchant/model';
import '../../sub2/data';
import '../../agenda/calendar';
import '../../devscustomattr/datatypes';
import './common_service';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "appointments": {
        "nested": {
          "api": {
            "nested": {
              "ChargeCheckoutPaymentRequest": {
                "fields": {
                  "reservationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "linkedToCustomer": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "idempotenceToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "tenderType": {
                    "type": ".squareup.bills.Tender.Type",
                    "id": 5,
                    "rule": "optional"
                  },
                  "otherTenderType": {
                    "type": ".squareup.bills.OtherTender.OtherTenderType",
                    "id": 6,
                    "rule": "optional"
                  },
                  "tipMoney": {
                    "type": ".squareup.common.Money",
                    "id": 7,
                    "rule": "optional"
                  },
                  "tipPercentage": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "verificationToken": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "creditPackIds": {
                    "type": "string",
                    "id": 13,
                    "rule": "repeated"
                  },
                  "instrumentToken": {
                    "type": "string",
                    "id": 3
                  },
                  "nonce": {
                    "type": "string",
                    "id": 9
                  },
                  "cardId": {
                    "type": "string",
                    "id": 12
                  },
                  "giftCardNonce": {
                    "type": "string",
                    "id": 14
                  }
                },
                "nested": {
                  "funding_source": {
                    "oneof": ["instrumentToken", "nonce", "cardId", "giftCardNonce"]
                  }
                }
              },
              "ChargeCheckoutPaymentResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "tenderServerTokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "CreatePaymentRequestRequest": {
                "fields": {
                  "bookingId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "clientMessage": {
                    "type": ".squareup.appointments.merchant.ClientMessage",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CreatePaymentRequestResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "RetrieveReservationOrderPreviewRequest": {
                "fields": {
                  "reservationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveReservationOrderPreviewResponse": {
                "fields": {
                  "order": {
                    "type": ".squareup.omg.model.Order",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ListActiveStaffRequest": {
                "fields": {}
              },
              "ListActiveStaffResponse": {
                "fields": {
                  "employeeToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "PutBusinessLocationRequest": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "openHours": {
                    "type": ".squareup.appointments.api.OpenHours",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "qrCodeFormat": {
                    "type": ".squareup.appointments.api.PutBusinessLocationRequest.QrCodeFormat",
                    "id": 3,
                    "rule": "optional"
                  },
                  "contractTemplateToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "onlineBookingEnabled": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "categoriesEnabled": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "marketplaceEnabled": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "serviceImagesEnabled": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "categoryImagesEnabled": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "QrCodeFormat": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "SIMPLE": 1,
                      "DETAILED": 2
                    }
                  }
                }
              },
              "PutBusinessLocationResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "PutRemoteSqlExecutionRequest": {
                "fields": {
                  "uid": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "statementResult": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PutRemoteSqlExecutionResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "SearchResourceAvailabilitiesRequest": {
                "fields": {
                  "query": {
                    "type": ".squareup.appointments.api.SearchResourceAvailabilitiesQuery",
                    "id": 1,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": 100
                    }
                  },
                  "cursor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "SearchResourceAvailabilitiesQuery": {
                "fields": {
                  "availableBetween": {
                    "type": ".squareup.connect.v2.common.TimeRange",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "itemVariationToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "ignoredReservationId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ResourceAvailability": {
                "fields": {
                  "resource": {
                    "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                    "id": 1,
                    "rule": "optional"
                  },
                  "available": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SearchResourceAvailabilitiesResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "resourceAvailabilities": {
                    "type": ".squareup.appointments.api.ResourceAvailability",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetExperimentVariationRequest": {
                "fields": {
                  "experimentName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetExperimentVariationResponse": {
                "fields": {
                  "variation": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetVideoCallRequest": {
                "fields": {
                  "appointmentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetVideoCallResponse": {
                "fields": {
                  "videoCallUrl": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "TextMatchType": {
                "values": {
                  "BEST_FIELDS": 0,
                  "PHRASE_PREFIX": 1,
                  "MOST_FIELDS": 2,
                  "CROSS_FIELDS": 3,
                  "PHRASE": 4,
                  "BOOL_PREFIX": 5
                }
              },
              "SearchMarketplaceAvailabilitiesQuery": {
                "fields": {
                  "filter": {
                    "type": ".squareup.appointments.api.SearchMarketplaceAvailabilitiesQuery.MarketplaceAvailabilitiesFilter",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sort": {
                    "type": ".squareup.appointments.api.SearchMarketplaceAvailabilitiesQuery.MarketplaceAvailabilitiesSort",
                    "id": 2,
                    "rule": "optional"
                  },
                  "searchIntent": {
                    "type": ".squareup.appointments.api.SearchMarketplaceAvailabilitiesQuery.SearchIntent",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "MarketplaceAvailabilitiesFilter": {
                    "fields": {
                      "text": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "minDateTime": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 2,
                        "rule": "optional"
                      },
                      "maxDateTime": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 3,
                        "rule": "optional"
                      },
                      "textMatchType": {
                        "type": ".squareup.appointments.api.TextMatchType",
                        "id": 6,
                        "rule": "optional"
                      },
                      "serviceCategoryId": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      },
                      "excludedUnitCategoryIds": {
                        "type": "string",
                        "id": 9,
                        "rule": "repeated"
                      },
                      "geoDistance": {
                        "type": ".squareup.appointments.api.GeoDistance",
                        "id": 4
                      },
                      "geoBoundingBox": {
                        "type": ".squareup.appointments.api.GeoBoundingBox",
                        "id": 5
                      },
                      "geoPoint": {
                        "type": ".squareup.appointments.api.GeoPoint",
                        "id": 7
                      }
                    },
                    "nested": {
                      "geo_filter": {
                        "oneof": ["geoDistance", "geoBoundingBox", "geoPoint"]
                      }
                    }
                  },
                  "MarketplaceAvailabilitiesSort": {
                    "fields": {
                      "field": {
                        "type": ".squareup.appointments.api.SearchMarketplaceAvailabilitiesQuery.MarketplaceAvailabilitiesSort.AvailabilitiesSortField",
                        "id": 1,
                        "rule": "optional"
                      },
                      "order": {
                        "type": ".squareup.connect.v2.common.SortOrder",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "AvailabilitiesSortField": {
                        "values": {
                          "DEFAULT": 0,
                          "GEO_DISTANCE": 1,
                          "TEXT_MATCH": 2,
                          "TOP_BOOKERS": 3
                        }
                      }
                    }
                  },
                  "SearchIntent": {
                    "fields": {
                      "category": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "SearchMarketplaceAvailabilitiesResult": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "variationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "unitDetail": {
                    "type": ".squareup.appointments.api.UnitDetail",
                    "id": 3,
                    "rule": "optional"
                  },
                  "serviceName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "variationName": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "serviceDescription": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "duration": {
                    "type": "int32",
                    "id": 7,
                    "rule": "optional"
                  },
                  "priceCents": {
                    "type": "int32",
                    "id": 8,
                    "rule": "optional"
                  },
                  "bookingLink": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "serviceImages": {
                    "type": ".squareup.appointments.api.SearchMarketplaceAvailabilitiesResult.Image",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "variationImages": {
                    "type": ".squareup.appointments.api.SearchMarketplaceAvailabilitiesResult.Image",
                    "id": 11,
                    "rule": "repeated"
                  },
                  "startTimes": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 12,
                    "rule": "repeated"
                  },
                  "adminData": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "unitServiceNames": {
                    "type": "string",
                    "id": 14,
                    "rule": "repeated"
                  },
                  "priceDescription": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Image": {
                    "fields": {
                      "url": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "SearchMarketplaceAvailabilitiesRequest": {
                "fields": {
                  "query": {
                    "type": ".squareup.appointments.api.SearchMarketplaceAvailabilitiesQuery",
                    "id": 1,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": 10
                    }
                  },
                  "adminOptions": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "MarketplaceFeatureFlagsRequest": {
                "fields": {}
              },
              "MarketplaceFeatureFlagsResponse": {
                "fields": {
                  "flags": {
                    "type": ".squareup.appointments.api.MarketplaceFeatureFlagsResponse.Flag",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Flag": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "boolValue": {
                        "type": "bool",
                        "id": 2
                      },
                      "stringValue": {
                        "type": "string",
                        "id": 3
                      },
                      "enumValue": {
                        "type": "string",
                        "id": 4
                      },
                      "longValue": {
                        "type": "int64",
                        "id": 5
                      }
                    },
                    "nested": {
                      "val": {
                        "oneof": ["boolValue", "stringValue", "enumValue", "longValue"]
                      }
                    }
                  }
                }
              },
              "ClientSupport": {
                "fields": {
                  "supportedFeatures": {
                    "type": ".squareup.appointments.api.ClientSupport.Feature",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Feature": {
                    "values": {
                      "UNIT_SNAPSHOT_SERVICE_VARIATION_GROUPS": 1
                    }
                  }
                }
              },
              "OccurrenceAvailabilitySearchRequest": {
                "fields": {
                  "searchRange": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 1,
                    "rule": "optional"
                  },
                  "occurrenceId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "OccurrenceAvailabilitySearchResponse": {
                "fields": {
                  "availabilities": {
                    "type": ".squareup.appointments.api.OccurrenceAvailabilitySearchResponse.Availability",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "durationSeconds": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "searchRange": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Availability": {
                    "fields": {
                      "bookingRequestToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "startTime": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "ReviewsReplyRequest": {
                "fields": {
                  "reviewId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "replyId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ReviewsReplyResponse": {
                "fields": {
                  "response": {
                    "type": ".squareup.appointments.api.AttributedReview.ReviewResponse",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "UnitDetail": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "imageUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.common.location.Address",
                    "id": 5,
                    "rule": "optional"
                  },
                  "openHours": {
                    "type": ".squareup.appointments.api.OpenHours",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "bookingSiteUrl": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "phone": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "unitDescription": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "latitude": {
                    "type": "double",
                    "id": 10,
                    "rule": "optional"
                  },
                  "longitude": {
                    "type": "double",
                    "id": 11,
                    "rule": "optional"
                  },
                  "bookingFlowUrl": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "cancellationPolicy": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "cutoffPolicy": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "buyerEditCutoffTime": {
                    "type": "int32",
                    "id": 15,
                    "rule": "optional"
                  },
                  "buyerCanEdit": {
                    "type": "bool",
                    "id": 16,
                    "rule": "optional"
                  },
                  "buyerCanBook": {
                    "type": "bool",
                    "id": 17,
                    "rule": "optional"
                  },
                  "confirmationLeadTime": {
                    "type": "int32",
                    "id": 18,
                    "rule": "optional"
                  },
                  "instagramUrl": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  },
                  "twitterUrl": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "facebookUrl": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  },
                  "websiteUrl": {
                    "type": "string",
                    "id": 22,
                    "rule": "optional"
                  },
                  "imageUrls": {
                    "type": "string",
                    "id": 23,
                    "rule": "repeated"
                  },
                  "totalBookings": {
                    "type": "int32",
                    "id": 24,
                    "rule": "optional"
                  },
                  "attributedImages": {
                    "type": ".squareup.appointments.api.AttributedImage",
                    "id": 25,
                    "rule": "repeated"
                  },
                  "rating": {
                    "type": "double",
                    "id": 26,
                    "rule": "optional"
                  },
                  "ratingCount": {
                    "type": "int32",
                    "id": 27,
                    "rule": "optional"
                  },
                  "ratingSource": {
                    "type": ".squareup.appointments.api.Attribution.Source",
                    "id": 28,
                    "rule": "optional"
                  },
                  "reviewsWithImages": {
                    "type": ".squareup.appointments.api.AttributedReview",
                    "id": 29,
                    "rule": "repeated"
                  }
                }
              },
              "SearchMarketplaceAvailabilitiesResponse": {
                "fields": {
                  "availabilities": {
                    "type": ".squareup.appointments.api.SearchMarketplaceAvailabilitiesResult",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "metadataSummary": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UnitSnapshot": {
                "fields": {
                  "unitDetail": {
                    "type": ".squareup.appointments.api.UnitDetail",
                    "id": 1,
                    "rule": "optional"
                  },
                  "employeeSamples": {
                    "type": ".squareup.appointments.api.EmployeeDetail",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "siblingUnitSamples": {
                    "type": ".squareup.appointments.api.UnitDetail",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "serviceSamples": {
                    "type": ".squareup.appointments.api.UnitSnapshot.ServiceSample",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "occurrenceFeedbacks": {
                    "type": ".squareup.appointments.api.OccurrenceFeedback",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "hasAdditionalServices": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "attributedImages": {
                    "type": ".squareup.appointments.api.AttributedImage",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "attributedReviews": {
                    "type": ".squareup.appointments.api.AttributedReview",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "ratingSummaries": {
                    "type": ".squareup.appointments.api.UnitSnapshot.RatingSummary",
                    "id": 10,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "ServiceSample": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "minDuration": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "maxDuration": {
                        "type": "int32",
                        "id": 3,
                        "rule": "optional"
                      },
                      "minPrice": {
                        "type": ".squareup.common.Money",
                        "id": 4,
                        "rule": "optional"
                      },
                      "maxPrice": {
                        "type": ".squareup.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "bookingLink": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "serviceDescription": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "availability": {
                        "type": ".squareup.appointments.api.UnitSnapshot.ServiceSample.AvailabilityDaySummary",
                        "id": 8,
                        "rule": "repeated"
                      },
                      "priceCents": {
                        "type": ".squareup.common.Money",
                        "id": 10,
                        "rule": "optional"
                      },
                      "variationSummaries": {
                        "type": ".squareup.appointments.api.UnitSnapshot.ServiceSample.VariationSummary",
                        "id": 11,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "AvailabilityDaySummary": {
                        "fields": {
                          "date": {
                            "type": ".squareup.common.time.YearMonthDay",
                            "id": 1,
                            "rule": "optional"
                          },
                          "firstSlot": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 2,
                            "rule": "optional"
                          },
                          "additionalSlotCount": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional"
                          },
                          "unitIsClosed": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional"
                          },
                          "bookingUrl": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "VariationSummary": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "duration": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "price": {
                            "type": ".squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "availability": {
                            "type": ".squareup.appointments.api.UnitSnapshot.ServiceSample.AvailabilityDaySummary",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "bookingLink": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "priceDescription": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "RatingSummary": {
                    "fields": {
                      "source": {
                        "type": ".squareup.appointments.api.Attribution.Source",
                        "id": 1,
                        "rule": "optional"
                      },
                      "rating": {
                        "type": "double",
                        "id": 2,
                        "rule": "optional"
                      },
                      "ratingCount": {
                        "type": "int32",
                        "id": 3,
                        "rule": "optional"
                      },
                      "attributedReviews": {
                        "type": ".squareup.appointments.api.AttributedReview",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "sourceUrl": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "ratingHistogram": {
                        "type": ".squareup.appointments.api.UnitSnapshot.RatingSummary.Histogram",
                        "id": 6,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Histogram": {
                        "fields": {
                          "one": {
                            "type": "int32",
                            "id": 1,
                            "rule": "optional"
                          },
                          "two": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "three": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional"
                          },
                          "four": {
                            "type": "int32",
                            "id": 4,
                            "rule": "optional"
                          },
                          "five": {
                            "type": "int32",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              },
              "AttributedImage": {
                "fields": {
                  "url": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "attribution": {
                    "type": ".squareup.appointments.api.Attribution",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "AttributedReview": {
                "fields": {
                  "rating": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "date": {
                    "type": ".squareup.common.time.YearMonthDay",
                    "id": 3,
                    "rule": "optional"
                  },
                  "variationDetails": {
                    "type": ".squareup.appointments.api.AttributedReview.VariationDetails",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "attribution": {
                    "type": ".squareup.appointments.api.Attribution",
                    "id": 5,
                    "rule": "optional"
                  },
                  "reviewToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "isEditable": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "images": {
                    "type": ".squareup.appointments.api.AttributedReview.Image",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "response": {
                    "type": ".squareup.appointments.api.AttributedReview.ReviewResponse",
                    "id": 9,
                    "rule": "optional"
                  },
                  "reviewedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 10,
                    "rule": "optional"
                  },
                  "isResponseAllowed": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  },
                  "reviewId": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "VariationDetails": {
                    "fields": {
                      "variationToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "variationName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "employeeDetails": {
                        "type": ".squareup.appointments.api.EmployeeDetail",
                        "id": 3,
                        "rule": "optional"
                      },
                      "bookingLink": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "serviceName": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "Image": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "url": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ReviewResponse": {
                    "fields": {
                      "author": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "profileImageUrl": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "text": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "date": {
                        "type": ".squareup.common.time.YearMonthDay",
                        "id": 4,
                        "rule": "optional"
                      },
                      "respondedAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "Attribution": {
                "fields": {
                  "source": {
                    "type": ".squareup.appointments.api.Attribution.Source",
                    "id": 1,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "linkUrl": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "imageUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Source": {
                    "values": {
                      "GO_MERCHANT_PROFILE": 0,
                      "SQUARE_MERCHANT_PROFILE": 1,
                      "GO_CURATED": 2,
                      "GOOGLE": 3
                    }
                  }
                }
              },
              "RetrieveUnitSnapshotRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "clientSupport": {
                    "type": ".squareup.appointments.api.ClientSupport",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveUnitSnapshotResponse": {
                "fields": {
                  "unitSnapshot": {
                    "type": ".squareup.appointments.api.UnitSnapshot",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "RetrieveRatingSummariesRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "pageSize": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "source": {
                    "type": ".squareup.appointments.api.Attribution.Source",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveRatingSummariesResponse": {
                "fields": {
                  "ratingSummaries": {
                    "type": ".squareup.appointments.api.UnitSnapshot.RatingSummary",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "SearchUnitsRequest": {
                "fields": {
                  "query": {
                    "type": ".squareup.appointments.api.SearchUnitsQuery",
                    "id": 1,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": 10
                    }
                  },
                  "cursor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "adminOptions": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "GeoPoint": {
                "fields": {
                  "latitude": {
                    "type": "double",
                    "id": 1,
                    "rule": "optional"
                  },
                  "longitude": {
                    "type": "double",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Distance": {
                "fields": {
                  "dimension": {
                    "type": ".squareup.appointments.api.Distance.Dimension",
                    "id": 1,
                    "rule": "optional"
                  },
                  "value": {
                    "type": "float",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Dimension": {
                    "values": {
                      "MILES": 0,
                      "KILOMETERS": 1
                    }
                  }
                }
              },
              "GeoDistance": {
                "fields": {
                  "radius": {
                    "type": ".squareup.appointments.api.Distance",
                    "id": 1,
                    "rule": "optional"
                  },
                  "center": {
                    "type": ".squareup.appointments.api.GeoPoint",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GeoBoundingBox": {
                "fields": {
                  "topLeft": {
                    "type": ".squareup.appointments.api.GeoPoint",
                    "id": 1,
                    "rule": "optional"
                  },
                  "bottomRight": {
                    "type": ".squareup.appointments.api.GeoPoint",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GeoFilter": {
                "fields": {
                  "geoDistance": {
                    "type": ".squareup.appointments.api.GeoDistance",
                    "id": 1
                  },
                  "geoBoundingBox": {
                    "type": ".squareup.appointments.api.GeoBoundingBox",
                    "id": 2
                  },
                  "geoPoint": {
                    "type": ".squareup.appointments.api.GeoPoint",
                    "id": 3
                  }
                },
                "nested": {
                  "geo_filter": {
                    "oneof": ["geoDistance", "geoBoundingBox", "geoPoint"]
                  }
                }
              },
              "SearchUnitsQuery": {
                "fields": {
                  "sort": {
                    "type": ".squareup.appointments.api.SearchUnitsQuery.UnitsSort",
                    "id": 1,
                    "rule": "optional"
                  },
                  "filter": {
                    "type": ".squareup.appointments.api.SearchUnitsQuery.UnitsFilter",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "UnitsSort": {
                    "fields": {
                      "field": {
                        "type": ".squareup.appointments.api.SearchUnitsQuery.UnitsSort.UnitsSortField",
                        "id": 1,
                        "rule": "optional"
                      },
                      "order": {
                        "type": ".squareup.connect.v2.common.SortOrder",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "UnitsSortField": {
                        "values": {
                          "DEFAULT": 0,
                          "UNIT_AGE": 1,
                          "TOP_BOOKERS": 2,
                          "TEXT_MATCH": 3,
                          "GEO_DISTANCE": 4
                        }
                      }
                    }
                  },
                  "UnitsFilter": {
                    "fields": {
                      "category": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "text": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "textMatchType": {
                        "type": ".squareup.appointments.api.TextMatchType",
                        "id": 5,
                        "rule": "optional"
                      },
                      "geoDistance": {
                        "type": ".squareup.appointments.api.GeoDistance",
                        "id": 1
                      },
                      "geoBoundingBox": {
                        "type": ".squareup.appointments.api.GeoBoundingBox",
                        "id": 2
                      },
                      "geoPoint": {
                        "type": ".squareup.appointments.api.GeoPoint",
                        "id": 6
                      }
                    },
                    "nested": {
                      "geo_filter": {
                        "oneof": ["geoDistance", "geoBoundingBox", "geoPoint"]
                      }
                    }
                  }
                }
              },
              "SearchUnitsResult": {
                "fields": {
                  "unitDetail": {
                    "type": ".squareup.appointments.api.UnitDetail",
                    "id": 1,
                    "rule": "optional"
                  },
                  "adminData": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SearchUnitsResponse": {
                "fields": {
                  "results": {
                    "type": ".squareup.appointments.api.SearchUnitsResult",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "metadataSummary": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ListMerchantCategoriesRequest": {
                "fields": {
                  "geoDistance": {
                    "type": ".squareup.appointments.api.GeoDistance",
                    "id": 1
                  },
                  "geoBoundingBox": {
                    "type": ".squareup.appointments.api.GeoBoundingBox",
                    "id": 2
                  }
                },
                "nested": {
                  "geo_filter": {
                    "oneof": ["geoDistance", "geoBoundingBox"]
                  }
                }
              },
              "ListMerchantCategoriesResponse": {
                "fields": {
                  "categories": {
                    "type": ".squareup.appointments.api.MerchantCategory",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "MerchantCategory": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "displayName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ListServiceCategoriesRequest": {
                "fields": {
                  "geoFilter": {
                    "type": ".squareup.appointments.api.GeoFilter",
                    "id": 1,
                    "rule": "optional"
                  },
                  "includeEmptyCategories": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ListServiceCategoriesResponse": {
                "fields": {
                  "categories": {
                    "type": ".squareup.appointments.api.ServiceCategory",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ServiceCategory": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "displayName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "iconUrl": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "subCategories": {
                    "type": ".squareup.appointments.api.ServiceCategory",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "fullDisplayName": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "ordinal": {
                    "type": "int32",
                    "id": 6,
                    "rule": "optional"
                  },
                  "isBrowsable": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "synonyms": {
                    "type": ".squareup.appointments.api.ServiceCategorySynonym",
                    "id": 8,
                    "rule": "repeated"
                  }
                }
              },
              "ServiceCategorySynonym": {
                "fields": {
                  "displayName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "ordinal": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveOccurrenceRequest": {
                "fields": {
                  "occurrenceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveOccurrenceResponse": {
                "fields": {
                  "occurrence": {
                    "type": ".squareup.appointments.api.Occurrence",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "ListOccurrencesForPersonRequest": {
                "fields": {
                  "limit": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": 1000
                    }
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ListOccurrencesForPersonResponse": {
                "fields": {
                  "occurrences": {
                    "type": ".squareup.appointments.api.Occurrence",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "RebookingSuggestionsRequest": {
                "fields": {
                  "unitTokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "excludeExistingBookings": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  }
                }
              },
              "RebookingSuggestionsResponse": {
                "fields": {
                  "rebookingSuggestions": {
                    "type": ".squareup.appointments.api.RebookingSuggestionsResponse.RebookingSuggestion",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "RebookingSuggestion": {
                    "fields": {
                      "heading": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "body": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "imageUrls": {
                        "type": "string",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "bookingLinkUrl": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "occurrence": {
                        "type": ".squareup.appointments.api.Occurrence",
                        "id": 5,
                        "rule": "optional"
                      },
                      "rebookingNotification": {
                        "type": ".squareup.appointments.api.RebookingSuggestionsResponse.RebookingSuggestion.RebookingNotification",
                        "id": 6,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "RebookingNotification": {
                        "fields": {
                          "notifyAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 1,
                            "rule": "optional"
                          },
                          "serviceCategoryId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              },
              "RebookingEligibilityRequest": {
                "fields": {
                  "occurrenceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RebookingEligibilityResponse": {
                "fields": {
                  "marketplaceAppSupported": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "webSupported": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "OccurrenceCheckinRequest": {
                "fields": {
                  "occurrenceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "OccurrenceCheckinResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "OccurrenceFeedbackRequest": {
                "fields": {
                  "occurrenceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "rating": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "messageToMerchant": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "useReviewsV2": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "imageIds": {
                    "type": "string",
                    "id": 5,
                    "rule": "repeated"
                  }
                }
              },
              "OccurrenceFeedbackResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "missingImageIds": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "OccurrenceFeedback": {
                "fields": {
                  "rating": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "messageToMerchant": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "buyerDisplayName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "variationDetails": {
                    "type": ".squareup.appointments.api.OccurrenceFeedback.VariationDetails",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "date": {
                    "type": ".squareup.common.time.YearMonthDay",
                    "id": 5,
                    "rule": "optional"
                  },
                  "buyerProfileImageUrl": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "reviewToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "VariationDetails": {
                    "fields": {
                      "variationToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "variationName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "employeeDetails": {
                        "type": ".squareup.appointments.api.EmployeeDetail",
                        "id": 3,
                        "rule": "optional"
                      },
                      "bookingLink": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "serviceName": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "UploadReviewImageRequest": {
                "fields": {
                  "images": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "UploadReviewImageResponse": {
                "fields": {
                  "uploads": {
                    "type": ".squareup.appointments.api.UploadReviewImageResponse.Metadata",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Metadata": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "hasSuccessfulScan": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GlobalBuyer": {
                "fields": {
                  "phone": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "firstName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.common.location.Address",
                    "id": 5,
                    "rule": "optional"
                  },
                  "profileImageUrl": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "settings": {
                    "type": ".squareup.appointments.api.GlobalBuyer.Settings",
                    "id": 7,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 8,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "int32",
                    "id": 10,
                    "rule": "optional"
                  },
                  "isOnboarded": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Settings": {
                    "fields": {
                      "pushNotificationsEnabled": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "smsNotificationsEnabled": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "UpsertGlobalBuyerRequest": {
                "fields": {
                  "globalBuyer": {
                    "type": ".squareup.appointments.api.GlobalBuyer",
                    "id": 1,
                    "rule": "optional"
                  },
                  "fieldsToClear": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "UpsertGlobalBuyerResponse": {
                "fields": {
                  "globalBuyer": {
                    "type": ".squareup.appointments.api.GlobalBuyer",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "RetrieveGlobalBuyerRequest": {
                "fields": {
                  "createIfNotExists": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveGlobalBuyerResponse": {
                "fields": {
                  "globalBuyer": {
                    "type": ".squareup.appointments.api.GlobalBuyer",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "DeleteGlobalBuyerRequest": {
                "fields": {}
              },
              "DeleteGlobalBuyerResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "UpsertProfileImageRequest": {
                "fields": {
                  "data": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UpsertProfileImageResponse": {
                "fields": {
                  "globalBuyer": {
                    "type": ".squareup.appointments.api.GlobalBuyer",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "Occurrence": {
                "fields": {
                  "occurrenceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "endDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "allDay": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "unitDetail": {
                    "type": ".squareup.appointments.api.UnitDetail",
                    "id": 6,
                    "rule": "optional"
                  },
                  "bookedVariationDetails": {
                    "type": ".squareup.appointments.api.Occurrence.BookedVariationDetail",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "status": {
                    "type": ".squareup.agenda.AppointmentStatus",
                    "id": 8,
                    "rule": "optional"
                  },
                  "confirmed": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "isEditable": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "unstableId": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  },
                  "editableUntil": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 12,
                    "rule": "optional"
                  },
                  "rebookingLink": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "feedback": {
                    "type": ".squareup.appointments.api.OccurrenceFeedback",
                    "id": 14,
                    "rule": "optional"
                  },
                  "attributedReview": {
                    "type": ".squareup.appointments.api.AttributedReview",
                    "id": 15,
                    "rule": "optional"
                  },
                  "reviewableUntil": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 16,
                    "rule": "optional"
                  },
                  "statusUpdatedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 17,
                    "rule": "optional"
                  },
                  "cancellableUntil": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 18,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BookedVariationDetail": {
                    "fields": {
                      "variationToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "variationName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "serviceName": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "duration": {
                        "type": "int32",
                        "id": 4,
                        "rule": "optional"
                      },
                      "price": {
                        "type": ".squareup.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "employeeDetails": {
                        "type": ".squareup.appointments.api.EmployeeDetail",
                        "id": 6,
                        "rule": "optional"
                      },
                      "bookingLink": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "priceType": {
                        "type": ".squareup.appointments.merchant.PriceType",
                        "id": 8,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "EmployeeDetail": {
                "fields": {
                  "employeeToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "shortName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "longName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "profileImageUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "showEmployee": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "bio": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "bookingLinkUrl": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "CancelOccurrenceRequest": {
                "fields": {
                  "occurrenceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CancelOccurrenceResponse": {
                "fields": {
                  "occurrence": {
                    "type": ".squareup.appointments.api.Occurrence",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "removedOccurrenceIds": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "RescheduleOccurrenceRequest": {
                "fields": {
                  "occurrenceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "bookingRequestToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RescheduleOccurrenceResponse": {
                "fields": {
                  "occurrence": {
                    "type": ".squareup.appointments.api.Occurrence",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "removedOccurrenceIds": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "RebookOccurrenceRequest": {
                "fields": {
                  "bookingRequestToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RebookOccurrenceResponse": {
                "fields": {
                  "occurrence": {
                    "type": ".squareup.appointments.api.Occurrence",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ConfirmOccurrenceRequest": {
                "fields": {
                  "occurrenceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ConfirmOccurrenceResponse": {
                "fields": {
                  "occurrence": {
                    "type": ".squareup.appointments.api.Occurrence",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ListRecommendedUnitsRequest": {
                "fields": {
                  "geoFilter": {
                    "type": ".squareup.appointments.api.GeoFilter",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListRecommendedUnitsResponse": {
                "fields": {
                  "recommendedUnits": {
                    "type": ".squareup.appointments.api.ListRecommendedUnitsResponse.RecommendedUnit",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "RecommendedUnit": {
                    "fields": {
                      "unitDetails": {
                        "type": ".squareup.appointments.api.UnitDetail",
                        "id": 1,
                        "rule": "optional"
                      },
                      "serviceNames": {
                        "type": "string",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              },
              "RetrieveMessengerPhoneNumberRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveMessengerPhoneNumberResponse": {
                "fields": {
                  "phoneNumber": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ValidateAccessCodeRequest": {
                "fields": {
                  "accessCode": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "location": {
                    "type": ".squareup.appointments.api.GeoPoint",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ValidateAccessCodeResponse": {
                "fields": {
                  "valid": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitDetail": {
                    "type": ".squareup.appointments.api.UnitDetail",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "MarketplaceAppAccessRequest": {
                "fields": {
                  "addToWaitlistIfDenied": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  }
                }
              },
              "MarketplaceAppAccessResponse": {
                "fields": {
                  "permitted": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "waitlisted": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "CreateMarketplaceInviteListEntryRequest": {
                "fields": {
                  "phone": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "zipcode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "languageCode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CreateMarketplaceInviteListEntryResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "Paywall": {
                "values": {
                  "NONE": 0,
                  "SUBSCRIPTION_ENDED": 1,
                  "SUBSCRIPTION_PAUSED": 2,
                  "SUBSCRIPTION_MISSING": 3,
                  "LOCATION_INACTIVE": 4
                }
              },
              "SubscriptionFeature": {
                "values": {
                  "DO_NOT_USE": 0,
                  "RETAIL": 1,
                  "RETAIL_RATE": 23,
                  "EMPLOYEE_MANAGEMENT": 4,
                  "APPOINTMENTS": 5,
                  "MARKETING": 2,
                  "MARKETING_SMS": 26,
                  "LOYALTY": 3,
                  "LOYALTY_INSIGHTS": 6,
                  "DIRECTORY": 7,
                  "CUSTOMER_DIRECTORY_SMART_DATA": 8,
                  "FEEDBACK": 9,
                  "MESSAGING": 10,
                  "CRM_ACTIVITY_LIST": 11,
                  "CRM_AUTO_PAYMENT_ASSIGNMENT": 12,
                  "CRM_INSIGHTS": 13,
                  "CRM_NOTES": 14,
                  "CRM_SMART_GROUPS": 15,
                  "CRM_SORTING": 16,
                  "CRM_LEGACY_SHOW_ALL_PAYMENTS": 17,
                  "CRM_LEGACY_CONTACT_LOOKUP": 18,
                  "CRM_CUSTOM_ATTRIBUTES": 20,
                  "ADVANCED_INVENTORY": 19,
                  "PREMIUM_SUPPORT": 21,
                  "RESTAURANTS": 22,
                  "SPOS_DEVICE_SETTINGS": 24,
                  "RETAIL_BASIC": 25,
                  "KDS": 27,
                  "PAYROLL": 28,
                  "INVOICES_PLUS": 29,
                  "APPOINTMENTS_FREE": 30,
                  "APPOINTMENTS_PLUS": 31,
                  "APPOINTMENTS_PREMIUM": 32,
                  "APPOINTMENTS_RESOURCE_MANAGEMENT": 33,
                  "COMMISSION_TRACKING": 34,
                  "APPOINTMENTS_CLASS_BOOKING": 35,
                  "APPOINTMENTS_SERVICE_COST": 36,
                  "APPOINTMENTS_CUSTOMER_BLOCKING": 97,
                  "APPOINTMENTS_CREDIT_PACKAGE": 104,
                  "APPOINTMENTS_PROCESSING_TIME": 1004,
                  "APPOINTMENTS_CONFIRMATIONS": 1000,
                  "APPOINTMENTS_NO_SHOW_PROTECTION": 1001,
                  "APPOINTMENTS_GOOGLE_CALENDAR_SYNC": 1002,
                  "APPOINTMENTS_DAILY_RESERVATION_LIMIT": 1003,
                  "APPOINTMENTS_MULTI_STAFF_RESERVATIONS": 1005,
                  "APPOINTMENTS_AUTOMATED_DIGITAL_CONTRACTS": 1006,
                  "APPOINTMENTS_API_WRITES": 1007,
                  "APPOINTMENTS_WAITLIST": 1008,
                  "APPOINTMENTS_REPORTING": 1009,
                  "APPOINTMENTS_SMS_TEMPLATING": 1010,
                  "APPOINTMENTS_CUSTOMER_FIELDS": 1011
                }
              },
              "GetSubscriptionRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetSubscriptionResponse": {
                "fields": {
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subscribedLocations": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "activeFeatures": {
                    "type": ".squareup.appointments.api.SubscriptionFeature",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "paywall": {
                    "type": ".squareup.appointments.api.Paywall",
                    "id": 4,
                    "rule": "optional"
                  },
                  "migrationState": {
                    "type": ".squareup.appointments.api.GetSubscriptionResponse.SubscriptionMigrationState",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "SubscriptionMigrationState": {
                    "values": {
                      "UNMIGRATED": 0,
                      "AUTO_MIGRATED": 1,
                      "AUTO_MIGRATION_ACKNOWLEDGED": 2,
                      "MANUALLY_MIGRATED": 3
                    }
                  }
                }
              },
              "UpdateSubscriptionRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "subscribedLocations": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "newSubscriptionPlanTokens": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "reason": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "UpdateSubscriptionResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "subscription": {
                    "type": ".squareup.sub2.data.Subscription",
                    "id": 2,
                    "rule": "optional"
                  },
                  "subscribedLocations": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "activeFeatures": {
                    "type": ".squareup.appointments.api.SubscriptionFeature",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "paywall": {
                    "type": ".squareup.appointments.api.Paywall",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "AcknowledgeSubscriptionRequest": {
                "fields": {}
              },
              "AcknowledgeSubscriptionResponse": {
                "fields": {}
              },
              "ClassSchedule": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "itemVariationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "itemVariationVersion": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "postBookingMessage": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "startAt": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "durationMinutes": {
                    "type": "int32",
                    "id": 7,
                    "rule": "optional"
                  },
                  "teamMemberId": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "resourceId": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "totalCapacity": {
                    "type": "int32",
                    "id": 10,
                    "rule": "optional"
                  },
                  "availableCapacity": {
                    "type": "int32",
                    "id": 11,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.appointments.api.ClassScheduleStatus",
                    "id": 12,
                    "rule": "optional"
                  },
                  "classBookings": {
                    "type": ".squareup.appointments.api.ClassBooking",
                    "id": 13,
                    "rule": "repeated"
                  },
                  "itemToken": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "rrule": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "exdates": {
                    "type": "string",
                    "id": 16,
                    "rule": "repeated"
                  },
                  "classScheduleSeriesId": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "recurrenceRule": {
                    "type": ".squareup.agenda.RecurrenceRule",
                    "id": 18,
                    "rule": "optional"
                  }
                }
              },
              "ClassScheduleStatus": {
                "values": {
                  "CLASS_SCHEDULE_STATUS_UNSPECIFIED": 0,
                  "CLASS_SCHEDULE_ACTIVE": 1,
                  "CLASS_SCHEDULE_CANCELED": 2
                }
              },
              "ClassBooking": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "classScheduleId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "customerId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "orderId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.appointments.api.ClassBookingStatus",
                    "id": 5,
                    "rule": "optional"
                  },
                  "refunded": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "startAt": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "ClassBookingStatus": {
                "values": {
                  "CLASS_BOOKING_STATUS_UNSPECIFIED": 0,
                  "CLASS_BOOKING_PENDING": 1,
                  "CLASS_BOOKING_ACCEPTED": 2,
                  "CLASS_BOOKING_CANCELED_BY_BUYER": 3,
                  "CLASS_BOOKING_CANCELED_BY_SELLER": 4,
                  "CLASS_BOOKING_NO_SHOW": 5
                }
              },
              "ClassScheduleInstance": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "classScheduleSeriesId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "classScheduleId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "startAt": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "deleted": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "availableCapacity": {
                    "type": "int32",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "SearchClassScheduleInstancesRequest": {
                "fields": {
                  "query": {
                    "type": ".squareup.appointments.api.SearchClassScheduleInstancesQuery",
                    "id": 1,
                    "rule": "optional"
                  },
                  "includes": {
                    "type": ".squareup.appointments.api.ClassesResource",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": 100
                    }
                  },
                  "sort": {
                    "type": ".squareup.appointments.api.ClassScheduleInstanceSort",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ClassesResource": {
                "values": {
                  "CLASSES_RESOURCES_UNSPECIFIED": 0,
                  "CLASS_SCHEDULE": 1
                }
              },
              "ClassScheduleInstanceSort": {
                "fields": {
                  "field": {
                    "type": ".squareup.appointments.api.ClassScheduleInstanceSortField",
                    "id": 1,
                    "rule": "optional"
                  },
                  "order": {
                    "type": ".squareup.connect.v2.common.SortOrder",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ClassScheduleInstanceSortField": {
                "values": {
                  "CLASS_SCHEDULE_INSTANCE_SORT_ORDER_UNSPECIFIED": 0,
                  "START_AT": 1
                }
              },
              "SearchClassScheduleInstancesQuery": {
                "fields": {
                  "filter": {
                    "type": ".squareup.appointments.api.SearchClassScheduleInstancesFilter",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SearchClassScheduleInstancesFilter": {
                "fields": {
                  "startingAt": {
                    "type": ".squareup.connect.v2.common.TimeRange",
                    "id": 1,
                    "rule": "optional"
                  },
                  "teamMemberIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "includeDeleted": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "classScheduleId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.appointments.api.ClassScheduleStatus",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "SearchClassScheduleInstancesResponse": {
                "fields": {
                  "classScheduleInstances": {
                    "type": ".squareup.appointments.api.ClassScheduleInstance",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "includedResources": {
                    "type": ".squareup.appointments.api.ClassesIncludedResources",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "ClassesIncludedResources": {
                "fields": {
                  "classSchedules": {
                    "type": ".squareup.appointments.api.ClassSchedule",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ListClassSchedulesRequest": {
                "fields": {
                  "startAtMin": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startAtMax": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "teamMemberId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": 100
                    }
                  }
                }
              },
              "ListClassSchedulesResponse": {
                "fields": {
                  "classSchedules": {
                    "type": ".squareup.appointments.api.ClassSchedule",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "SearchClassSchedulesRequest": {
                "fields": {
                  "query": {
                    "type": ".squareup.appointments.api.SearchClassSchedulesQuery",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": 100
                    }
                  }
                }
              },
              "SearchClassSchedulesQuery": {
                "fields": {
                  "filter": {
                    "type": ".squareup.appointments.api.SearchClassSchedulesFilter",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SearchClassSchedulesFilter": {
                "fields": {
                  "startingAt": {
                    "type": ".squareup.connect.v2.common.TimeRange",
                    "id": 1,
                    "rule": "optional"
                  },
                  "teamMemberIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "SearchClassSchedulesResponse": {
                "fields": {
                  "classSchedules": {
                    "type": ".squareup.appointments.api.ClassSchedule",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "RetrieveClassScheduleRequest": {
                "fields": {
                  "classScheduleId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startAt": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveClassScheduleResponse": {
                "fields": {
                  "classSchedule": {
                    "type": ".squareup.appointments.api.ClassSchedule",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "CreateClassScheduleRequest": {
                "fields": {
                  "idempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "classSchedule": {
                    "type": ".squareup.appointments.api.ClassSchedule",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CreateClassScheduleResponse": {
                "fields": {
                  "classSchedule": {
                    "type": ".squareup.appointments.api.ClassSchedule",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "UpdateClassScheduleRequest": {
                "fields": {
                  "idempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "classScheduleId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "classSchedule": {
                    "type": ".squareup.appointments.api.ClassSchedule",
                    "id": 3,
                    "rule": "optional"
                  },
                  "startAt": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "updateType": {
                    "type": ".squareup.appointments.api.ClassScheduleUpdateType",
                    "id": 5,
                    "rule": "optional"
                  },
                  "fieldsToClear": {
                    "type": "string",
                    "id": 6,
                    "rule": "repeated"
                  }
                }
              },
              "ClassScheduleUpdateType": {
                "values": {
                  "UNSPECIFIED": 0,
                  "ALL": 1,
                  "THIS_INSTANCE": 2,
                  "THIS_AND_ALL_FOLLOWING": 3
                }
              },
              "UpdateClassScheduleResponse": {
                "fields": {
                  "classSchedule": {
                    "type": ".squareup.appointments.api.ClassSchedule",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "newClassSchedule": {
                    "type": ".squareup.appointments.api.ClassSchedule",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CancelClassScheduleRequest": {
                "fields": {
                  "classScheduleId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startAt": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "updateType": {
                    "type": ".squareup.appointments.api.ClassScheduleUpdateType",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": "THIS_INSTANCE"
                    }
                  }
                }
              },
              "CancelClassScheduleResponse": {
                "fields": {
                  "classSchedule": {
                    "type": ".squareup.appointments.api.ClassSchedule",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ListClassBookingsRequest": {
                "fields": {
                  "startAtMin": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startAtMax": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "classScheduleId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "customerId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": 100
                    }
                  },
                  "classScheduleSeriesId": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "ListClassBookingsResponse": {
                "fields": {
                  "classBookings": {
                    "type": ".squareup.appointments.api.ClassBooking",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "SearchClassBookingsRequest": {
                "fields": {
                  "query": {
                    "type": ".squareup.appointments.api.SearchClassBookingsQuery",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": 100
                    }
                  },
                  "include": {
                    "type": ".squareup.appointments.api.SearchClassBookingsRequest.ClassBookingResource",
                    "id": 4,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "ClassBookingResource": {
                    "values": {
                      "CLASS_BOOKING_RESOURCE_UNSPECIFIED": 0,
                      "CLASS_SCHEDULES": 1
                    }
                  }
                }
              },
              "SearchClassBookingsQuery": {
                "fields": {
                  "filter": {
                    "type": ".squareup.appointments.api.SearchClassBookingsFilter",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sort": {
                    "type": ".squareup.appointments.api.ClassBookingsSort",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SearchClassBookingsFilter": {
                "fields": {
                  "startAtMin": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startAtMax": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "classScheduleId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "customerId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "classScheduleSeriesId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ClassBookingsSort": {
                "fields": {
                  "field": {
                    "type": ".squareup.appointments.api.ClassBookingsSort.ClassBookingsSortField",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": "START_AT"
                    }
                  },
                  "order": {
                    "type": ".squareup.connect.v2.common.SortOrder",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": "ASC"
                    }
                  }
                },
                "nested": {
                  "ClassBookingsSortField": {
                    "values": {
                      "CLASS_BOOKINGS_SORT_ORDER_UNSPECIFIED": 0,
                      "START_AT": 1
                    }
                  }
                }
              },
              "SearchClassBookingsResponse": {
                "fields": {
                  "classBookings": {
                    "type": ".squareup.appointments.api.ClassBooking",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "includedResources": {
                    "type": ".squareup.appointments.api.ClassBookingIncludedResources",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ClassBookingIncludedResources": {
                "fields": {
                  "classSchedules": {
                    "type": ".squareup.appointments.api.ClassSchedule",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "RetrieveClassBookingRequest": {
                "fields": {
                  "classBookingId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveClassBookingResponse": {
                "fields": {
                  "classBooking": {
                    "type": ".squareup.appointments.api.ClassBooking",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "CreateClassBookingRequest": {
                "fields": {
                  "idempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "classBooking": {
                    "type": ".squareup.appointments.api.ClassBooking",
                    "id": 2,
                    "rule": "optional"
                  },
                  "clientMessage": {
                    "type": ".squareup.appointments.merchant.ClientMessage",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CreateClassBookingResponse": {
                "fields": {
                  "classBooking": {
                    "type": ".squareup.appointments.api.ClassBooking",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "UpdateClassBookingRequest": {
                "fields": {
                  "idempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "classBooking": {
                    "type": ".squareup.appointments.api.ClassBooking",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdateClassBookingResponse": {
                "fields": {
                  "classBooking": {
                    "type": ".squareup.appointments.api.ClassBooking",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "CancelClassBookingRequest": {
                "fields": {
                  "classBookingId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "clientMessage": {
                    "type": ".squareup.appointments.merchant.ClientMessage",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CancelClassBookingResponse": {
                "fields": {
                  "classBooking": {
                    "type": ".squareup.appointments.api.ClassBooking",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "CompleteClassBookingRequest": {
                "fields": {
                  "idempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "classBooking": {
                    "type": ".squareup.appointments.api.ClassBooking",
                    "id": 2,
                    "rule": "optional"
                  },
                  "paymentSourceId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "creditPackIds": {
                    "type": "string",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "verificationToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "CompleteClassBookingResponse": {
                "fields": {
                  "classBooking": {
                    "type": ".squareup.appointments.api.ClassBooking",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "PayClassBookingRequest": {
                "fields": {
                  "idempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "classBookingId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "paymentSourceId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "creditPackIds": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "PayClassBookingResponse": {
                "fields": {
                  "classBooking": {
                    "type": ".squareup.appointments.api.ClassBooking",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "RetrieveClassesProfileRequest": {
                "fields": {}
              },
              "RetrieveClassesProfileResponse": {
                "fields": {
                  "isUsingClasses": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "hasClassSchedulesInFuture": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "closestPastClassAt": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "closestFutureClassAt": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "EnableCustomerBlockingRequest": {
                "fields": {
                  "idempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "EnableCustomerBlockingResponse": {
                "fields": {
                  "customAttributeDefinition": {
                    "type": ".squareup.devscustomattr.service.CustomAttributeDefinition",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ValidateAposDataResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ExternalAppointmentsService": {
                "methods": {
                  "ChargeCheckoutPayment": {
                    "requestType": ".squareup.appointments.api.ChargeCheckoutPaymentRequest",
                    "responseType": ".squareup.appointments.api.ChargeCheckoutPaymentResponse"
                  },
                  "CreatePaymentRequest": {
                    "requestType": ".squareup.appointments.api.CreatePaymentRequestRequest",
                    "responseType": ".squareup.appointments.api.CreatePaymentRequestResponse"
                  },
                  "RetrieveReservationOrderPreview": {
                    "requestType": ".squareup.appointments.api.RetrieveReservationOrderPreviewRequest",
                    "responseType": ".squareup.appointments.api.RetrieveReservationOrderPreviewResponse"
                  },
                  "ListActiveStaff": {
                    "requestType": ".squareup.appointments.api.ListActiveStaffRequest",
                    "responseType": ".squareup.appointments.api.ListActiveStaffResponse"
                  },
                  "PutBusinessLocation": {
                    "requestType": ".squareup.appointments.api.PutBusinessLocationRequest",
                    "responseType": ".squareup.appointments.api.PutBusinessLocationResponse"
                  },
                  "SearchResourceAvailabilities": {
                    "requestType": ".squareup.appointments.api.SearchResourceAvailabilitiesRequest",
                    "responseType": ".squareup.appointments.api.SearchResourceAvailabilitiesResponse"
                  },
                  "PutRemoteSqlExecution": {
                    "requestType": ".squareup.appointments.api.PutRemoteSqlExecutionRequest",
                    "responseType": ".squareup.appointments.api.PutRemoteSqlExecutionResponse"
                  },
                  "ListReservationsForContact": {
                    "requestType": ".squareup.appointments.api.ListReservationsForContactRequest",
                    "responseType": ".squareup.appointments.api.ListReservationsForContactResponse"
                  },
                  "GetSubscription": {
                    "requestType": ".squareup.appointments.api.GetSubscriptionRequest",
                    "responseType": ".squareup.appointments.api.GetSubscriptionResponse"
                  },
                  "UpdateSubscription": {
                    "requestType": ".squareup.appointments.api.UpdateSubscriptionRequest",
                    "responseType": ".squareup.appointments.api.UpdateSubscriptionResponse"
                  },
                  "AcknowledgeSubscription": {
                    "requestType": ".squareup.appointments.api.AcknowledgeSubscriptionRequest",
                    "responseType": ".squareup.appointments.api.AcknowledgeSubscriptionResponse"
                  },
                  "GetVideoCall": {
                    "requestType": ".squareup.appointments.api.GetVideoCallRequest",
                    "responseType": ".squareup.appointments.api.GetVideoCallResponse"
                  },
                  "GetExperimentVariation": {
                    "requestType": ".squareup.appointments.api.GetExperimentVariationRequest",
                    "responseType": ".squareup.appointments.api.GetExperimentVariationResponse"
                  },
                  "EnableCustomerBlocking": {
                    "requestType": ".squareup.appointments.api.EnableCustomerBlockingRequest",
                    "responseType": ".squareup.appointments.api.EnableCustomerBlockingResponse"
                  },
                  "SearchMarketplaceAvailabilities": {
                    "requestType": ".squareup.appointments.api.SearchMarketplaceAvailabilitiesRequest",
                    "responseType": ".squareup.appointments.api.SearchMarketplaceAvailabilitiesResponse"
                  },
                  "SearchUnits": {
                    "requestType": ".squareup.appointments.api.SearchUnitsRequest",
                    "responseType": ".squareup.appointments.api.SearchUnitsResponse"
                  },
                  "RetrieveUnitSnapshot": {
                    "requestType": ".squareup.appointments.api.RetrieveUnitSnapshotRequest",
                    "responseType": ".squareup.appointments.api.RetrieveUnitSnapshotResponse"
                  },
                  "RetrieveRatingSummaries": {
                    "requestType": ".squareup.appointments.api.RetrieveRatingSummariesRequest",
                    "responseType": ".squareup.appointments.api.RetrieveRatingSummariesResponse"
                  },
                  "ListMerchantCategories": {
                    "requestType": ".squareup.appointments.api.ListMerchantCategoriesRequest",
                    "responseType": ".squareup.appointments.api.ListMerchantCategoriesResponse"
                  },
                  "ListServiceCategories": {
                    "requestType": ".squareup.appointments.api.ListServiceCategoriesRequest",
                    "responseType": ".squareup.appointments.api.ListServiceCategoriesResponse"
                  },
                  "RetrieveOccurrence": {
                    "requestType": ".squareup.appointments.api.RetrieveOccurrenceRequest",
                    "responseType": ".squareup.appointments.api.RetrieveOccurrenceResponse"
                  },
                  "ListOccurrencesForPerson": {
                    "requestType": ".squareup.appointments.api.ListOccurrencesForPersonRequest",
                    "responseType": ".squareup.appointments.api.ListOccurrencesForPersonResponse"
                  },
                  "RebookingSuggestions": {
                    "requestType": ".squareup.appointments.api.RebookingSuggestionsRequest",
                    "responseType": ".squareup.appointments.api.RebookingSuggestionsResponse"
                  },
                  "RebookingEligibility": {
                    "requestType": ".squareup.appointments.api.RebookingEligibilityRequest",
                    "responseType": ".squareup.appointments.api.RebookingEligibilityResponse"
                  },
                  "CancelOccurrence": {
                    "requestType": ".squareup.appointments.api.CancelOccurrenceRequest",
                    "responseType": ".squareup.appointments.api.CancelOccurrenceResponse"
                  },
                  "RebookOccurrence": {
                    "requestType": ".squareup.appointments.api.RebookOccurrenceRequest",
                    "responseType": ".squareup.appointments.api.RebookOccurrenceResponse"
                  },
                  "RescheduleOccurrence": {
                    "requestType": ".squareup.appointments.api.RescheduleOccurrenceRequest",
                    "responseType": ".squareup.appointments.api.RescheduleOccurrenceResponse"
                  },
                  "ConfirmOccurrence": {
                    "requestType": ".squareup.appointments.api.ConfirmOccurrenceRequest",
                    "responseType": ".squareup.appointments.api.ConfirmOccurrenceResponse"
                  },
                  "OccurrenceCheckin": {
                    "requestType": ".squareup.appointments.api.OccurrenceCheckinRequest",
                    "responseType": ".squareup.appointments.api.OccurrenceCheckinResponse"
                  },
                  "OccurrenceFeedback": {
                    "requestType": ".squareup.appointments.api.OccurrenceFeedbackRequest",
                    "responseType": ".squareup.appointments.api.OccurrenceFeedbackResponse"
                  },
                  "UploadReviewImage": {
                    "requestType": ".squareup.appointments.api.UploadReviewImageRequest",
                    "responseType": ".squareup.appointments.api.UploadReviewImageResponse"
                  },
                  "ListRecommendedUnits": {
                    "requestType": ".squareup.appointments.api.ListRecommendedUnitsRequest",
                    "responseType": ".squareup.appointments.api.ListRecommendedUnitsResponse"
                  },
                  "UpsertGlobalBuyer": {
                    "requestType": ".squareup.appointments.api.UpsertGlobalBuyerRequest",
                    "responseType": ".squareup.appointments.api.UpsertGlobalBuyerResponse"
                  },
                  "DeleteGlobalBuyer": {
                    "requestType": ".squareup.appointments.api.DeleteGlobalBuyerRequest",
                    "responseType": ".squareup.appointments.api.DeleteGlobalBuyerResponse"
                  },
                  "UpsertProfileImage": {
                    "requestType": ".squareup.appointments.api.UpsertProfileImageRequest",
                    "responseType": ".squareup.appointments.api.UpsertProfileImageResponse"
                  },
                  "RetrieveGlobalBuyer": {
                    "requestType": ".squareup.appointments.api.RetrieveGlobalBuyerRequest",
                    "responseType": ".squareup.appointments.api.RetrieveGlobalBuyerResponse"
                  },
                  "RetrieveMessengerPhoneNumber": {
                    "requestType": ".squareup.appointments.api.RetrieveMessengerPhoneNumberRequest",
                    "responseType": ".squareup.appointments.api.RetrieveMessengerPhoneNumberResponse"
                  },
                  "MarketplaceAppAccess": {
                    "requestType": ".squareup.appointments.api.MarketplaceAppAccessRequest",
                    "responseType": ".squareup.appointments.api.MarketplaceAppAccessResponse"
                  },
                  "MarketplaceFeatureFlags": {
                    "requestType": ".squareup.appointments.api.MarketplaceFeatureFlagsRequest",
                    "responseType": ".squareup.appointments.api.MarketplaceFeatureFlagsResponse"
                  },
                  "ValidateAccessCode": {
                    "requestType": ".squareup.appointments.api.ValidateAccessCodeRequest",
                    "responseType": ".squareup.appointments.api.ValidateAccessCodeResponse"
                  },
                  "CreateMarketplaceInviteListEntry": {
                    "requestType": ".squareup.appointments.api.CreateMarketplaceInviteListEntryRequest",
                    "responseType": ".squareup.appointments.api.CreateMarketplaceInviteListEntryResponse"
                  },
                  "OccurrenceAvailabilitySearch": {
                    "requestType": ".squareup.appointments.api.OccurrenceAvailabilitySearchRequest",
                    "responseType": ".squareup.appointments.api.OccurrenceAvailabilitySearchResponse"
                  },
                  "ReviewsReply": {
                    "requestType": ".squareup.appointments.api.ReviewsReplyRequest",
                    "responseType": ".squareup.appointments.api.ReviewsReplyResponse"
                  },
                  "ListClassSchedules": {
                    "requestType": ".squareup.appointments.api.ListClassSchedulesRequest",
                    "responseType": ".squareup.appointments.api.ListClassSchedulesResponse"
                  },
                  "SearchClassSchedules": {
                    "requestType": ".squareup.appointments.api.SearchClassSchedulesRequest",
                    "responseType": ".squareup.appointments.api.SearchClassSchedulesResponse"
                  },
                  "RetrieveClassSchedule": {
                    "requestType": ".squareup.appointments.api.RetrieveClassScheduleRequest",
                    "responseType": ".squareup.appointments.api.RetrieveClassScheduleResponse"
                  },
                  "SearchClassScheduleInstances": {
                    "requestType": ".squareup.appointments.api.SearchClassScheduleInstancesRequest",
                    "responseType": ".squareup.appointments.api.SearchClassScheduleInstancesResponse"
                  },
                  "CreateClassSchedule": {
                    "requestType": ".squareup.appointments.api.CreateClassScheduleRequest",
                    "responseType": ".squareup.appointments.api.CreateClassScheduleResponse"
                  },
                  "UpdateClassSchedule": {
                    "requestType": ".squareup.appointments.api.UpdateClassScheduleRequest",
                    "responseType": ".squareup.appointments.api.UpdateClassScheduleResponse"
                  },
                  "CancelClassSchedule": {
                    "requestType": ".squareup.appointments.api.CancelClassScheduleRequest",
                    "responseType": ".squareup.appointments.api.CancelClassScheduleResponse"
                  },
                  "ListClassBookings": {
                    "requestType": ".squareup.appointments.api.ListClassBookingsRequest",
                    "responseType": ".squareup.appointments.api.ListClassBookingsResponse"
                  },
                  "SearchClassBookings": {
                    "requestType": ".squareup.appointments.api.SearchClassBookingsRequest",
                    "responseType": ".squareup.appointments.api.SearchClassBookingsResponse"
                  },
                  "RetrieveClassBooking": {
                    "requestType": ".squareup.appointments.api.RetrieveClassBookingRequest",
                    "responseType": ".squareup.appointments.api.RetrieveClassBookingResponse"
                  },
                  "CreateClassBooking": {
                    "requestType": ".squareup.appointments.api.CreateClassBookingRequest",
                    "responseType": ".squareup.appointments.api.CreateClassBookingResponse"
                  },
                  "UpdateClassBooking": {
                    "requestType": ".squareup.appointments.api.UpdateClassBookingRequest",
                    "responseType": ".squareup.appointments.api.UpdateClassBookingResponse"
                  },
                  "CancelClassBooking": {
                    "requestType": ".squareup.appointments.api.CancelClassBookingRequest",
                    "responseType": ".squareup.appointments.api.CancelClassBookingResponse"
                  },
                  "CompleteClassBooking": {
                    "requestType": ".squareup.appointments.api.CompleteClassBookingRequest",
                    "responseType": ".squareup.appointments.api.CompleteClassBookingResponse"
                  },
                  "PayClassBooking": {
                    "requestType": ".squareup.appointments.api.PayClassBookingRequest",
                    "responseType": ".squareup.appointments.api.PayClassBookingResponse"
                  },
                  "RetrieveClassesProfile": {
                    "requestType": ".squareup.appointments.api.RetrieveClassesProfileRequest",
                    "responseType": ".squareup.appointments.api.RetrieveClassesProfileResponse"
                  },
                  "ValidateAposData": {
                    "requestType": ".squareup.agenda.ValidateAposDataRequest",
                    "responseType": ".squareup.appointments.api.ValidateAposDataResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ChargeCheckoutPaymentRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ChargeCheckoutPaymentResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CreatePaymentRequestRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CreatePaymentRequestResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveReservationOrderPreviewRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveReservationOrderPreviewResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ListActiveStaffRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ListActiveStaffResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.PutBusinessLocationRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.PutBusinessLocationRequest?.nested?.QrCodeFormat && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.PutBusinessLocationResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.PutRemoteSqlExecutionRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.PutRemoteSqlExecutionResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchResourceAvailabilitiesRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchResourceAvailabilitiesQuery && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ResourceAvailability && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchResourceAvailabilitiesResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.GetExperimentVariationRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.GetExperimentVariationResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.GetVideoCallRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.GetVideoCallResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.TextMatchType && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchMarketplaceAvailabilitiesQuery && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchMarketplaceAvailabilitiesQuery?.nested?.MarketplaceAvailabilitiesFilter && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchMarketplaceAvailabilitiesQuery?.nested?.MarketplaceAvailabilitiesSort && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchMarketplaceAvailabilitiesQuery?.nested?.MarketplaceAvailabilitiesSort?.nested?.AvailabilitiesSortField && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchMarketplaceAvailabilitiesQuery?.nested?.SearchIntent && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchMarketplaceAvailabilitiesResult && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchMarketplaceAvailabilitiesResult?.nested?.Image && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchMarketplaceAvailabilitiesRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.MarketplaceFeatureFlagsRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.MarketplaceFeatureFlagsResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.MarketplaceFeatureFlagsResponse?.nested?.Flag && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ClientSupport && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ClientSupport?.nested?.Feature && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.OccurrenceAvailabilitySearchRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.OccurrenceAvailabilitySearchResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.OccurrenceAvailabilitySearchResponse?.nested?.Availability && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ReviewsReplyRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ReviewsReplyResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UnitDetail && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchMarketplaceAvailabilitiesResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UnitSnapshot && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UnitSnapshot?.nested?.ServiceSample && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UnitSnapshot?.nested?.ServiceSample?.nested?.AvailabilityDaySummary && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UnitSnapshot?.nested?.ServiceSample?.nested?.VariationSummary && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UnitSnapshot?.nested?.RatingSummary && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UnitSnapshot?.nested?.RatingSummary?.nested?.Histogram && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.AttributedImage && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.AttributedReview && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.AttributedReview?.nested?.VariationDetails && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.AttributedReview?.nested?.Image && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.AttributedReview?.nested?.ReviewResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.Attribution && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.Attribution?.nested?.Source && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveUnitSnapshotRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveUnitSnapshotResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveRatingSummariesRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveRatingSummariesResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchUnitsRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.GeoPoint && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.Distance && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.Distance?.nested?.Dimension && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.GeoDistance && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.GeoBoundingBox && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.GeoFilter && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchUnitsQuery && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchUnitsQuery?.nested?.UnitsSort && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchUnitsQuery?.nested?.UnitsSort?.nested?.UnitsSortField && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchUnitsQuery?.nested?.UnitsFilter && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchUnitsResult && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchUnitsResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ListMerchantCategoriesRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ListMerchantCategoriesResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.MerchantCategory && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ListServiceCategoriesRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ListServiceCategoriesResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ServiceCategory && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ServiceCategorySynonym && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveOccurrenceRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveOccurrenceResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ListOccurrencesForPersonRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ListOccurrencesForPersonResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RebookingSuggestionsRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RebookingSuggestionsResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RebookingSuggestionsResponse?.nested?.RebookingSuggestion && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RebookingSuggestionsResponse?.nested?.RebookingSuggestion?.nested?.RebookingNotification && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RebookingEligibilityRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RebookingEligibilityResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.OccurrenceCheckinRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.OccurrenceCheckinResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.OccurrenceFeedbackRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.OccurrenceFeedbackResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.OccurrenceFeedback && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.OccurrenceFeedback?.nested?.VariationDetails && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UploadReviewImageRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UploadReviewImageResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UploadReviewImageResponse?.nested?.Metadata && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.GlobalBuyer && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.GlobalBuyer?.nested?.Settings && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UpsertGlobalBuyerRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UpsertGlobalBuyerResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveGlobalBuyerRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveGlobalBuyerResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.DeleteGlobalBuyerRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.DeleteGlobalBuyerResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UpsertProfileImageRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UpsertProfileImageResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.Occurrence && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.Occurrence?.nested?.BookedVariationDetail && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.EmployeeDetail && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CancelOccurrenceRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CancelOccurrenceResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RescheduleOccurrenceRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RescheduleOccurrenceResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RebookOccurrenceRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RebookOccurrenceResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ConfirmOccurrenceRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ConfirmOccurrenceResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ListRecommendedUnitsRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ListRecommendedUnitsResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ListRecommendedUnitsResponse?.nested?.RecommendedUnit && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveMessengerPhoneNumberRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveMessengerPhoneNumberResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ValidateAccessCodeRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ValidateAccessCodeResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.MarketplaceAppAccessRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.MarketplaceAppAccessResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CreateMarketplaceInviteListEntryRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CreateMarketplaceInviteListEntryResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.Paywall && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SubscriptionFeature && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.GetSubscriptionRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.GetSubscriptionResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.GetSubscriptionResponse?.nested?.SubscriptionMigrationState && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UpdateSubscriptionRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UpdateSubscriptionResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.AcknowledgeSubscriptionRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.AcknowledgeSubscriptionResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ClassSchedule && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ClassScheduleStatus && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ClassBooking && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ClassBookingStatus && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ClassScheduleInstance && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchClassScheduleInstancesRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ClassesResource && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ClassScheduleInstanceSort && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ClassScheduleInstanceSortField && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchClassScheduleInstancesQuery && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchClassScheduleInstancesFilter && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchClassScheduleInstancesResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ClassesIncludedResources && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ListClassSchedulesRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ListClassSchedulesResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchClassSchedulesRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchClassSchedulesQuery && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchClassSchedulesFilter && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchClassSchedulesResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveClassScheduleRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveClassScheduleResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CreateClassScheduleRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CreateClassScheduleResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UpdateClassScheduleRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ClassScheduleUpdateType && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UpdateClassScheduleResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CancelClassScheduleRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CancelClassScheduleResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ListClassBookingsRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ListClassBookingsResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchClassBookingsRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchClassBookingsRequest?.nested?.ClassBookingResource && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchClassBookingsQuery && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchClassBookingsFilter && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ClassBookingsSort && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ClassBookingsSort?.nested?.ClassBookingsSortField && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.SearchClassBookingsResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ClassBookingIncludedResources && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveClassBookingRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveClassBookingResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CreateClassBookingRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CreateClassBookingResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UpdateClassBookingRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.UpdateClassBookingResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CancelClassBookingRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CancelClassBookingResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CompleteClassBookingRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.CompleteClassBookingResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.PayClassBookingRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.PayClassBookingResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveClassesProfileRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.RetrieveClassesProfileResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.EnableCustomerBlockingRequest && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.EnableCustomerBlockingResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ValidateAposDataResponse && !$root.nested?.squareup?.nested?.appointments?.nested?.api?.nested?.ExternalAppointmentsService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ChargeCheckoutPaymentRequest @ squareup/appointments/api/external_service.proto at 31:1
 */
export const ChargeCheckoutPaymentRequest = $root.lookupType('squareup.appointments.api.ChargeCheckoutPaymentRequest');
fixType(ChargeCheckoutPaymentRequest, {
  reservationId: {
    required: true
  }
});
Builder.createAndAttachToType(ChargeCheckoutPaymentRequest);
/**
 * SOURCE ChargeCheckoutPaymentResponse @ squareup/appointments/api/external_service.proto at 74:1
 */
export const ChargeCheckoutPaymentResponse = $root.lookupType('squareup.appointments.api.ChargeCheckoutPaymentResponse');
fixType(ChargeCheckoutPaymentResponse);
Builder.createAndAttachToType(ChargeCheckoutPaymentResponse);
/**
 * SOURCE CreatePaymentRequestRequest @ squareup/appointments/api/external_service.proto at 79:1
 */
export const CreatePaymentRequestRequest = $root.lookupType('squareup.appointments.api.CreatePaymentRequestRequest');
fixType(CreatePaymentRequestRequest, {
  bookingId: {
    required: true
  }
});
Builder.createAndAttachToType(CreatePaymentRequestRequest);
/**
 * SOURCE CreatePaymentRequestResponse @ squareup/appointments/api/external_service.proto at 87:1
 */
export const CreatePaymentRequestResponse = $root.lookupType('squareup.appointments.api.CreatePaymentRequestResponse');
fixType(CreatePaymentRequestResponse);
Builder.createAndAttachToType(CreatePaymentRequestResponse);
/**
 * SOURCE RetrieveReservationOrderPreviewRequest @ squareup/appointments/api/external_service.proto at 91:1
 */
export const RetrieveReservationOrderPreviewRequest = $root.lookupType('squareup.appointments.api.RetrieveReservationOrderPreviewRequest');
fixType(RetrieveReservationOrderPreviewRequest, {
  reservationId: {
    required: true
  }
});
Builder.createAndAttachToType(RetrieveReservationOrderPreviewRequest);
/**
 * SOURCE RetrieveReservationOrderPreviewResponse @ squareup/appointments/api/external_service.proto at 99:1
 */
export const RetrieveReservationOrderPreviewResponse = $root.lookupType('squareup.appointments.api.RetrieveReservationOrderPreviewResponse');
fixType(RetrieveReservationOrderPreviewResponse);
Builder.createAndAttachToType(RetrieveReservationOrderPreviewResponse);
/**
 * Return list of active staff's employee tokens depending on the current users permissions
 *
 * SOURCE ListActiveStaffRequest @ squareup/appointments/api/external_service.proto at 110:1
 */
export const ListActiveStaffRequest = $root.lookupType('squareup.appointments.api.ListActiveStaffRequest');
fixType(ListActiveStaffRequest);
Builder.createAndAttachToType(ListActiveStaffRequest);
/**
 * SOURCE ListActiveStaffResponse @ squareup/appointments/api/external_service.proto at 113:1
 */
export const ListActiveStaffResponse = $root.lookupType('squareup.appointments.api.ListActiveStaffResponse');
fixType(ListActiveStaffResponse);
Builder.createAndAttachToType(ListActiveStaffResponse);
/**
 * SOURCE PutBusinessLocationRequest @ squareup/appointments/api/external_service.proto at 117:1
 */
export const PutBusinessLocationRequest = $root.lookupType('squareup.appointments.api.PutBusinessLocationRequest');
fixType(PutBusinessLocationRequest, {
  id: {
    required: true
  }
});
Builder.createAndAttachToType(PutBusinessLocationRequest);
/**
 * SOURCE QrCodeFormat @ squareup/appointments/api/external_service.proto at 121:3
 */
PutBusinessLocationRequest.QrCodeFormat = $root.lookupEnum('squareup.appointments.api.PutBusinessLocationRequest.QrCodeFormat').values;
/**
 * SOURCE PutBusinessLocationResponse @ squareup/appointments/api/external_service.proto at 157:1
 */
export const PutBusinessLocationResponse = $root.lookupType('squareup.appointments.api.PutBusinessLocationResponse');
fixType(PutBusinessLocationResponse);
Builder.createAndAttachToType(PutBusinessLocationResponse);
/**
 * SOURCE PutRemoteSqlExecutionRequest @ squareup/appointments/api/external_service.proto at 161:1
 */
export const PutRemoteSqlExecutionRequest = $root.lookupType('squareup.appointments.api.PutRemoteSqlExecutionRequest');
fixType(PutRemoteSqlExecutionRequest);
Builder.createAndAttachToType(PutRemoteSqlExecutionRequest);
/**
 * SOURCE PutRemoteSqlExecutionResponse @ squareup/appointments/api/external_service.proto at 169:1
 */
export const PutRemoteSqlExecutionResponse = $root.lookupType('squareup.appointments.api.PutRemoteSqlExecutionResponse');
fixType(PutRemoteSqlExecutionResponse);
Builder.createAndAttachToType(PutRemoteSqlExecutionResponse);
/**
 * SOURCE SearchResourceAvailabilitiesRequest @ squareup/appointments/api/external_service.proto at 174:1
 */
export const SearchResourceAvailabilitiesRequest = $root.lookupType('squareup.appointments.api.SearchResourceAvailabilitiesRequest');
fixType(SearchResourceAvailabilitiesRequest);
Builder.createAndAttachToType(SearchResourceAvailabilitiesRequest);
/**
 * SOURCE SearchResourceAvailabilitiesQuery @ squareup/appointments/api/external_service.proto at 185:1
 */
export const SearchResourceAvailabilitiesQuery = $root.lookupType('squareup.appointments.api.SearchResourceAvailabilitiesQuery');
fixType(SearchResourceAvailabilitiesQuery);
Builder.createAndAttachToType(SearchResourceAvailabilitiesQuery);
/**
 * SOURCE ResourceAvailability @ squareup/appointments/api/external_service.proto at 204:1
 */
export const ResourceAvailability = $root.lookupType('squareup.appointments.api.ResourceAvailability');
fixType(ResourceAvailability);
Builder.createAndAttachToType(ResourceAvailability);
/**
 * SOURCE SearchResourceAvailabilitiesResponse @ squareup/appointments/api/external_service.proto at 212:1
 */
export const SearchResourceAvailabilitiesResponse = $root.lookupType('squareup.appointments.api.SearchResourceAvailabilitiesResponse');
fixType(SearchResourceAvailabilitiesResponse);
Builder.createAndAttachToType(SearchResourceAvailabilitiesResponse);
/**
 * SOURCE GetExperimentVariationRequest @ squareup/appointments/api/external_service.proto at 222:1
 */
export const GetExperimentVariationRequest = $root.lookupType('squareup.appointments.api.GetExperimentVariationRequest');
fixType(GetExperimentVariationRequest, {
  experimentName: {
    required: true
  }
});
Builder.createAndAttachToType(GetExperimentVariationRequest);
/**
 * SOURCE GetExperimentVariationResponse @ squareup/appointments/api/external_service.proto at 226:1
 */
export const GetExperimentVariationResponse = $root.lookupType('squareup.appointments.api.GetExperimentVariationResponse');
fixType(GetExperimentVariationResponse);
Builder.createAndAttachToType(GetExperimentVariationResponse);
/**
 * DEPRECATED, do not use. Actually marking as deprecated breaks iOS.
 *
 * SOURCE GetVideoCallRequest @ squareup/appointments/api/external_service.proto at 231:1
 */
export const GetVideoCallRequest = $root.lookupType('squareup.appointments.api.GetVideoCallRequest');
fixType(GetVideoCallRequest, {
  appointmentId: {
    required: true
  },
  startDate: {
    required: true
  }
});
Builder.createAndAttachToType(GetVideoCallRequest);
/**
 * DEPRECATED, do not use. Actually marking as deprecated breaks iOS.
 *
 * SOURCE GetVideoCallResponse @ squareup/appointments/api/external_service.proto at 237:1
 */
export const GetVideoCallResponse = $root.lookupType('squareup.appointments.api.GetVideoCallResponse');
fixType(GetVideoCallResponse);
Builder.createAndAttachToType(GetVideoCallResponse);
/**
 * https://www.elastic.co/guide/en/elasticsearch/reference/current/query-dsl-multi-match-query.html#multi-match-types
 * Backend may not implement these exactly as described, but for now this is exactly what is used.
 *
 * SOURCE TextMatchType @ squareup/appointments/api/external_service.proto at 244:1
 */
export const TextMatchType = $root.lookupEnum('squareup.appointments.api.TextMatchType').values;
/**
 * SOURCE SearchMarketplaceAvailabilitiesQuery @ squareup/appointments/api/external_service.proto at 253:1
 */
export const SearchMarketplaceAvailabilitiesQuery = $root.lookupType('squareup.appointments.api.SearchMarketplaceAvailabilitiesQuery');
fixType(SearchMarketplaceAvailabilitiesQuery);
Builder.createAndAttachToType(SearchMarketplaceAvailabilitiesQuery);
/**
 * SOURCE MarketplaceAvailabilitiesFilter @ squareup/appointments/api/external_service.proto at 254:3
 */
SearchMarketplaceAvailabilitiesQuery.MarketplaceAvailabilitiesFilter = $root.lookupType('squareup.appointments.api.SearchMarketplaceAvailabilitiesQuery.MarketplaceAvailabilitiesFilter');
fixType(SearchMarketplaceAvailabilitiesQuery.MarketplaceAvailabilitiesFilter);
Builder.createAndAttachToType(SearchMarketplaceAvailabilitiesQuery.MarketplaceAvailabilitiesFilter);
/**
 * SOURCE MarketplaceAvailabilitiesSort @ squareup/appointments/api/external_service.proto at 283:3
 */
SearchMarketplaceAvailabilitiesQuery.MarketplaceAvailabilitiesSort = $root.lookupType('squareup.appointments.api.SearchMarketplaceAvailabilitiesQuery.MarketplaceAvailabilitiesSort');
fixType(SearchMarketplaceAvailabilitiesQuery.MarketplaceAvailabilitiesSort);
Builder.createAndAttachToType(SearchMarketplaceAvailabilitiesQuery.MarketplaceAvailabilitiesSort);
/**
 * SOURCE AvailabilitiesSortField @ squareup/appointments/api/external_service.proto at 284:5
 */
SearchMarketplaceAvailabilitiesQuery.MarketplaceAvailabilitiesSort.AvailabilitiesSortField = $root.lookupEnum('squareup.appointments.api.SearchMarketplaceAvailabilitiesQuery.MarketplaceAvailabilitiesSort.AvailabilitiesSortField').values;
/**
 * SOURCE SearchIntent @ squareup/appointments/api/external_service.proto at 308:3
 */
SearchMarketplaceAvailabilitiesQuery.SearchIntent = $root.lookupType('squareup.appointments.api.SearchMarketplaceAvailabilitiesQuery.SearchIntent');
fixType(SearchMarketplaceAvailabilitiesQuery.SearchIntent);
Builder.createAndAttachToType(SearchMarketplaceAvailabilitiesQuery.SearchIntent);
/**
 * SOURCE SearchMarketplaceAvailabilitiesResult @ squareup/appointments/api/external_service.proto at 316:1
 */
export const SearchMarketplaceAvailabilitiesResult = $root.lookupType('squareup.appointments.api.SearchMarketplaceAvailabilitiesResult');
fixType(SearchMarketplaceAvailabilitiesResult);
Builder.createAndAttachToType(SearchMarketplaceAvailabilitiesResult);
/**
 * SOURCE Image @ squareup/appointments/api/external_service.proto at 342:3
 */
SearchMarketplaceAvailabilitiesResult.Image = $root.lookupType('squareup.appointments.api.SearchMarketplaceAvailabilitiesResult.Image');
fixType(SearchMarketplaceAvailabilitiesResult.Image, {
  url: {
    required: true
  }
});
Builder.createAndAttachToType(SearchMarketplaceAvailabilitiesResult.Image);
/**
 * SOURCE SearchMarketplaceAvailabilitiesRequest @ squareup/appointments/api/external_service.proto at 367:1
 */
export const SearchMarketplaceAvailabilitiesRequest = $root.lookupType('squareup.appointments.api.SearchMarketplaceAvailabilitiesRequest');
fixType(SearchMarketplaceAvailabilitiesRequest);
Builder.createAndAttachToType(SearchMarketplaceAvailabilitiesRequest);
/**
 * The `person_token` from the logged in buyer session will be used for any feature flag overrides.
 *
 * SOURCE MarketplaceFeatureFlagsRequest @ squareup/appointments/api/external_service.proto at 384:1
 */
export const MarketplaceFeatureFlagsRequest = $root.lookupType('squareup.appointments.api.MarketplaceFeatureFlagsRequest');
fixType(MarketplaceFeatureFlagsRequest);
Builder.createAndAttachToType(MarketplaceFeatureFlagsRequest);
/**
 * Flags will be returned in the `squarego` group, added to the `appointments` app.
 *
 * SOURCE MarketplaceFeatureFlagsResponse @ squareup/appointments/api/external_service.proto at 388:1
 */
export const MarketplaceFeatureFlagsResponse = $root.lookupType('squareup.appointments.api.MarketplaceFeatureFlagsResponse');
fixType(MarketplaceFeatureFlagsResponse);
Builder.createAndAttachToType(MarketplaceFeatureFlagsResponse);
/**
 * SOURCE Flag @ squareup/appointments/api/external_service.proto at 389:3
 */
MarketplaceFeatureFlagsResponse.Flag = $root.lookupType('squareup.appointments.api.MarketplaceFeatureFlagsResponse.Flag');
fixType(MarketplaceFeatureFlagsResponse.Flag, {
  name: {
    required: true
  }
});
Builder.createAndAttachToType(MarketplaceFeatureFlagsResponse.Flag);
/**
 * SOURCE ClientSupport @ squareup/appointments/api/external_service.proto at 409:1
 */
export const ClientSupport = $root.lookupType('squareup.appointments.api.ClientSupport');
fixType(ClientSupport);
Builder.createAndAttachToType(ClientSupport);
/**
 * SOURCE Feature @ squareup/appointments/api/external_service.proto at 410:3
 */
ClientSupport.Feature = $root.lookupEnum('squareup.appointments.api.ClientSupport.Feature').values;
/**
 * Search for available slots to book an appointment at a specific location.
 *
 * SOURCE OccurrenceAvailabilitySearchRequest @ squareup/appointments/api/external_service.proto at 418:1
 */
export const OccurrenceAvailabilitySearchRequest = $root.lookupType('squareup.appointments.api.OccurrenceAvailabilitySearchRequest');
fixType(OccurrenceAvailabilitySearchRequest, {
  occurrenceId: {
    required: true
  }
});
Builder.createAndAttachToType(OccurrenceAvailabilitySearchRequest);
/**
 * SOURCE OccurrenceAvailabilitySearchResponse @ squareup/appointments/api/external_service.proto at 428:1
 */
export const OccurrenceAvailabilitySearchResponse = $root.lookupType('squareup.appointments.api.OccurrenceAvailabilitySearchResponse');
fixType(OccurrenceAvailabilitySearchResponse);
Builder.createAndAttachToType(OccurrenceAvailabilitySearchResponse);
/**
 * SOURCE Availability @ squareup/appointments/api/external_service.proto at 429:3
 */
OccurrenceAvailabilitySearchResponse.Availability = $root.lookupType('squareup.appointments.api.OccurrenceAvailabilitySearchResponse.Availability');
fixType(OccurrenceAvailabilitySearchResponse.Availability, {
  bookingRequestToken: {
    required: true
  },
  startTime: {
    required: true
  }
});
Builder.createAndAttachToType(OccurrenceAvailabilitySearchResponse.Availability);
/**
 * SOURCE ReviewsReplyRequest @ squareup/appointments/api/external_service.proto at 452:1
 */
export const ReviewsReplyRequest = $root.lookupType('squareup.appointments.api.ReviewsReplyRequest');
fixType(ReviewsReplyRequest, {
  reviewId: {
    required: true
  },
  text: {
    required: true
  }
});
Builder.createAndAttachToType(ReviewsReplyRequest);
/**
 * SOURCE ReviewsReplyResponse @ squareup/appointments/api/external_service.proto at 463:1
 */
export const ReviewsReplyResponse = $root.lookupType('squareup.appointments.api.ReviewsReplyResponse');
fixType(ReviewsReplyResponse);
Builder.createAndAttachToType(ReviewsReplyResponse);
/**
 * SOURCE UnitDetail @ squareup/appointments/api/external_service.proto at 471:1
 */
export const UnitDetail = $root.lookupType('squareup.appointments.api.UnitDetail');
fixType(UnitDetail);
Builder.createAndAttachToType(UnitDetail);
/**
 * SOURCE SearchMarketplaceAvailabilitiesResponse @ squareup/appointments/api/external_service.proto at 562:1
 */
export const SearchMarketplaceAvailabilitiesResponse = $root.lookupType('squareup.appointments.api.SearchMarketplaceAvailabilitiesResponse');
fixType(SearchMarketplaceAvailabilitiesResponse);
Builder.createAndAttachToType(SearchMarketplaceAvailabilitiesResponse);
/**
 * SOURCE UnitSnapshot @ squareup/appointments/api/external_service.proto at 575:1
 */
export const UnitSnapshot = $root.lookupType('squareup.appointments.api.UnitSnapshot');
fixType(UnitSnapshot);
Builder.createAndAttachToType(UnitSnapshot);
/**
 * SOURCE ServiceSample @ squareup/appointments/api/external_service.proto at 585:3
 */
UnitSnapshot.ServiceSample = $root.lookupType('squareup.appointments.api.UnitSnapshot.ServiceSample');
fixType(UnitSnapshot.ServiceSample);
Builder.createAndAttachToType(UnitSnapshot.ServiceSample);
/**
 * SOURCE AvailabilityDaySummary @ squareup/appointments/api/external_service.proto at 601:5
 */
UnitSnapshot.ServiceSample.AvailabilityDaySummary = $root.lookupType('squareup.appointments.api.UnitSnapshot.ServiceSample.AvailabilityDaySummary');
fixType(UnitSnapshot.ServiceSample.AvailabilityDaySummary, {
  date: {
    required: true
  }
});
Builder.createAndAttachToType(UnitSnapshot.ServiceSample.AvailabilityDaySummary);
/**
 * SOURCE VariationSummary @ squareup/appointments/api/external_service.proto at 628:5
 */
UnitSnapshot.ServiceSample.VariationSummary = $root.lookupType('squareup.appointments.api.UnitSnapshot.ServiceSample.VariationSummary');
fixType(UnitSnapshot.ServiceSample.VariationSummary);
Builder.createAndAttachToType(UnitSnapshot.ServiceSample.VariationSummary);
/**
 * SOURCE RatingSummary @ squareup/appointments/api/external_service.proto at 662:3
 */
UnitSnapshot.RatingSummary = $root.lookupType('squareup.appointments.api.UnitSnapshot.RatingSummary');
fixType(UnitSnapshot.RatingSummary);
Builder.createAndAttachToType(UnitSnapshot.RatingSummary);
/**
 * SOURCE Histogram @ squareup/appointments/api/external_service.proto at 678:5
 */
UnitSnapshot.RatingSummary.Histogram = $root.lookupType('squareup.appointments.api.UnitSnapshot.RatingSummary.Histogram');
fixType(UnitSnapshot.RatingSummary.Histogram);
Builder.createAndAttachToType(UnitSnapshot.RatingSummary.Histogram);
/**
 * SOURCE AttributedImage @ squareup/appointments/api/external_service.proto at 693:1
 */
export const AttributedImage = $root.lookupType('squareup.appointments.api.AttributedImage');
fixType(AttributedImage);
Builder.createAndAttachToType(AttributedImage);
/**
 * SOURCE AttributedReview @ squareup/appointments/api/external_service.proto at 699:1
 */
export const AttributedReview = $root.lookupType('squareup.appointments.api.AttributedReview');
fixType(AttributedReview, {
  rating: {
    required: true
  }
});
Builder.createAndAttachToType(AttributedReview);
/**
 * SOURCE VariationDetails @ squareup/appointments/api/external_service.proto at 713:3
 */
AttributedReview.VariationDetails = $root.lookupType('squareup.appointments.api.AttributedReview.VariationDetails');
fixType(AttributedReview.VariationDetails);
Builder.createAndAttachToType(AttributedReview.VariationDetails);
/**
 * SOURCE Image @ squareup/appointments/api/external_service.proto at 739:3
 */
AttributedReview.Image = $root.lookupType('squareup.appointments.api.AttributedReview.Image');
fixType(AttributedReview.Image);
Builder.createAndAttachToType(AttributedReview.Image);
/**
 * SOURCE ReviewResponse @ squareup/appointments/api/external_service.proto at 748:3
 */
AttributedReview.ReviewResponse = $root.lookupType('squareup.appointments.api.AttributedReview.ReviewResponse');
fixType(AttributedReview.ReviewResponse);
Builder.createAndAttachToType(AttributedReview.ReviewResponse);
/**
 * SOURCE Attribution @ squareup/appointments/api/external_service.proto at 775:1
 */
export const Attribution = $root.lookupType('squareup.appointments.api.Attribution');
fixType(Attribution);
Builder.createAndAttachToType(Attribution);
/**
 * SOURCE Source @ squareup/appointments/api/external_service.proto at 776:3
 */
Attribution.Source = $root.lookupEnum('squareup.appointments.api.Attribution.Source').values;
/**
 * SOURCE RetrieveUnitSnapshotRequest @ squareup/appointments/api/external_service.proto at 802:1
 */
export const RetrieveUnitSnapshotRequest = $root.lookupType('squareup.appointments.api.RetrieveUnitSnapshotRequest');
fixType(RetrieveUnitSnapshotRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveUnitSnapshotRequest);
/**
 * SOURCE RetrieveUnitSnapshotResponse @ squareup/appointments/api/external_service.proto at 808:1
 */
export const RetrieveUnitSnapshotResponse = $root.lookupType('squareup.appointments.api.RetrieveUnitSnapshotResponse');
fixType(RetrieveUnitSnapshotResponse);
Builder.createAndAttachToType(RetrieveUnitSnapshotResponse);
/**
 * SOURCE RetrieveRatingSummariesRequest @ squareup/appointments/api/external_service.proto at 815:1
 */
export const RetrieveRatingSummariesRequest = $root.lookupType('squareup.appointments.api.RetrieveRatingSummariesRequest');
fixType(RetrieveRatingSummariesRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveRatingSummariesRequest);
/**
 * SOURCE RetrieveRatingSummariesResponse @ squareup/appointments/api/external_service.proto at 828:1
 */
export const RetrieveRatingSummariesResponse = $root.lookupType('squareup.appointments.api.RetrieveRatingSummariesResponse');
fixType(RetrieveRatingSummariesResponse);
Builder.createAndAttachToType(RetrieveRatingSummariesResponse);
/**
 * SOURCE SearchUnitsRequest @ squareup/appointments/api/external_service.proto at 838:1
 */
export const SearchUnitsRequest = $root.lookupType('squareup.appointments.api.SearchUnitsRequest');
fixType(SearchUnitsRequest);
Builder.createAndAttachToType(SearchUnitsRequest);
/**
 * SOURCE GeoPoint @ squareup/appointments/api/external_service.proto at 856:1
 */
export const GeoPoint = $root.lookupType('squareup.appointments.api.GeoPoint');
fixType(GeoPoint, {
  latitude: {
    required: true
  },
  longitude: {
    required: true
  }
});
Builder.createAndAttachToType(GeoPoint);
/**
 * SOURCE Distance @ squareup/appointments/api/external_service.proto at 872:1
 */
export const Distance = $root.lookupType('squareup.appointments.api.Distance');
fixType(Distance, {
  dimension: {
    required: true
  },
  value: {
    required: true
  }
});
Builder.createAndAttachToType(Distance);
/**
 * Should only contain dimensions that elastic search supports:
 * https://www.elastic.co/guide/en/elasticsearch/reference/current/common-options.html#distance-units
 *
 * SOURCE Dimension @ squareup/appointments/api/external_service.proto at 875:3
 */
Distance.Dimension = $root.lookupEnum('squareup.appointments.api.Distance.Dimension').values;
/**
 * SOURCE GeoDistance @ squareup/appointments/api/external_service.proto at 884:1
 */
export const GeoDistance = $root.lookupType('squareup.appointments.api.GeoDistance');
fixType(GeoDistance, {
  radius: {
    required: true
  },
  center: {
    required: true
  }
});
Builder.createAndAttachToType(GeoDistance);
/**
 * SOURCE GeoBoundingBox @ squareup/appointments/api/external_service.proto at 889:1
 */
export const GeoBoundingBox = $root.lookupType('squareup.appointments.api.GeoBoundingBox');
fixType(GeoBoundingBox, {
  topLeft: {
    required: true
  },
  bottomRight: {
    required: true
  }
});
Builder.createAndAttachToType(GeoBoundingBox);
/**
 * SOURCE GeoFilter @ squareup/appointments/api/external_service.proto at 894:1
 */
export const GeoFilter = $root.lookupType('squareup.appointments.api.GeoFilter');
fixType(GeoFilter);
Builder.createAndAttachToType(GeoFilter);
/**
 * SOURCE SearchUnitsQuery @ squareup/appointments/api/external_service.proto at 902:1
 */
export const SearchUnitsQuery = $root.lookupType('squareup.appointments.api.SearchUnitsQuery');
fixType(SearchUnitsQuery);
Builder.createAndAttachToType(SearchUnitsQuery);
/**
 * SOURCE UnitsSort @ squareup/appointments/api/external_service.proto at 903:3
 */
SearchUnitsQuery.UnitsSort = $root.lookupType('squareup.appointments.api.SearchUnitsQuery.UnitsSort');
fixType(SearchUnitsQuery.UnitsSort);
Builder.createAndAttachToType(SearchUnitsQuery.UnitsSort);
/**
 * SOURCE UnitsSortField @ squareup/appointments/api/external_service.proto at 904:5
 */
SearchUnitsQuery.UnitsSort.UnitsSortField = $root.lookupEnum('squareup.appointments.api.SearchUnitsQuery.UnitsSort.UnitsSortField').values;
/**
 * SOURCE UnitsFilter @ squareup/appointments/api/external_service.proto at 930:3
 */
SearchUnitsQuery.UnitsFilter = $root.lookupType('squareup.appointments.api.SearchUnitsQuery.UnitsFilter');
fixType(SearchUnitsQuery.UnitsFilter);
Builder.createAndAttachToType(SearchUnitsQuery.UnitsFilter);
/**
 * SOURCE SearchUnitsResult @ squareup/appointments/api/external_service.proto at 952:1
 */
export const SearchUnitsResult = $root.lookupType('squareup.appointments.api.SearchUnitsResult');
fixType(SearchUnitsResult);
Builder.createAndAttachToType(SearchUnitsResult);
/**
 * SOURCE SearchUnitsResponse @ squareup/appointments/api/external_service.proto at 960:1
 */
export const SearchUnitsResponse = $root.lookupType('squareup.appointments.api.SearchUnitsResponse');
fixType(SearchUnitsResponse);
Builder.createAndAttachToType(SearchUnitsResponse);
/**
 * SOURCE ListMerchantCategoriesRequest @ squareup/appointments/api/external_service.proto at 976:1
 */
export const ListMerchantCategoriesRequest = $root.lookupType('squareup.appointments.api.ListMerchantCategoriesRequest');
fixType(ListMerchantCategoriesRequest);
Builder.createAndAttachToType(ListMerchantCategoriesRequest);
/**
 * SOURCE ListMerchantCategoriesResponse @ squareup/appointments/api/external_service.proto at 984:1
 */
export const ListMerchantCategoriesResponse = $root.lookupType('squareup.appointments.api.ListMerchantCategoriesResponse');
fixType(ListMerchantCategoriesResponse);
Builder.createAndAttachToType(ListMerchantCategoriesResponse);
/**
 * SOURCE MerchantCategory @ squareup/appointments/api/external_service.proto at 992:1
 */
export const MerchantCategory = $root.lookupType('squareup.appointments.api.MerchantCategory');
fixType(MerchantCategory);
Builder.createAndAttachToType(MerchantCategory);
/**
 * SOURCE ListServiceCategoriesRequest @ squareup/appointments/api/external_service.proto at 998:1
 */
export const ListServiceCategoriesRequest = $root.lookupType('squareup.appointments.api.ListServiceCategoriesRequest');
fixType(ListServiceCategoriesRequest);
Builder.createAndAttachToType(ListServiceCategoriesRequest);
/**
 * SOURCE ListServiceCategoriesResponse @ squareup/appointments/api/external_service.proto at 1006:1
 */
export const ListServiceCategoriesResponse = $root.lookupType('squareup.appointments.api.ListServiceCategoriesResponse');
fixType(ListServiceCategoriesResponse);
Builder.createAndAttachToType(ListServiceCategoriesResponse);
/**
 * SOURCE ServiceCategory @ squareup/appointments/api/external_service.proto at 1012:1
 */
export const ServiceCategory = $root.lookupType('squareup.appointments.api.ServiceCategory');
fixType(ServiceCategory);
Builder.createAndAttachToType(ServiceCategory);
/**
 * SOURCE ServiceCategorySynonym @ squareup/appointments/api/external_service.proto at 1030:1
 */
export const ServiceCategorySynonym = $root.lookupType('squareup.appointments.api.ServiceCategorySynonym');
fixType(ServiceCategorySynonym);
Builder.createAndAttachToType(ServiceCategorySynonym);
/**
 * SOURCE RetrieveOccurrenceRequest @ squareup/appointments/api/external_service.proto at 1037:1
 */
export const RetrieveOccurrenceRequest = $root.lookupType('squareup.appointments.api.RetrieveOccurrenceRequest');
fixType(RetrieveOccurrenceRequest);
Builder.createAndAttachToType(RetrieveOccurrenceRequest);
/**
 * SOURCE RetrieveOccurrenceResponse @ squareup/appointments/api/external_service.proto at 1042:1
 */
export const RetrieveOccurrenceResponse = $root.lookupType('squareup.appointments.api.RetrieveOccurrenceResponse');
fixType(RetrieveOccurrenceResponse);
Builder.createAndAttachToType(RetrieveOccurrenceResponse);
/**
 * SOURCE ListOccurrencesForPersonRequest @ squareup/appointments/api/external_service.proto at 1050:1
 */
export const ListOccurrencesForPersonRequest = $root.lookupType('squareup.appointments.api.ListOccurrencesForPersonRequest');
fixType(ListOccurrencesForPersonRequest);
Builder.createAndAttachToType(ListOccurrencesForPersonRequest);
/**
 * SOURCE ListOccurrencesForPersonResponse @ squareup/appointments/api/external_service.proto at 1061:1
 */
export const ListOccurrencesForPersonResponse = $root.lookupType('squareup.appointments.api.ListOccurrencesForPersonResponse');
fixType(ListOccurrencesForPersonResponse);
Builder.createAndAttachToType(ListOccurrencesForPersonResponse);
/**
 * Suggestions will be for the logged in multipass buyer
 *
 * SOURCE RebookingSuggestionsRequest @ squareup/appointments/api/external_service.proto at 1073:1
 */
export const RebookingSuggestionsRequest = $root.lookupType('squareup.appointments.api.RebookingSuggestionsRequest');
fixType(RebookingSuggestionsRequest);
Builder.createAndAttachToType(RebookingSuggestionsRequest);
/**
 * SOURCE RebookingSuggestionsResponse @ squareup/appointments/api/external_service.proto at 1083:1
 */
export const RebookingSuggestionsResponse = $root.lookupType('squareup.appointments.api.RebookingSuggestionsResponse');
fixType(RebookingSuggestionsResponse);
Builder.createAndAttachToType(RebookingSuggestionsResponse);
/**
 * SOURCE RebookingSuggestion @ squareup/appointments/api/external_service.proto at 1084:3
 */
RebookingSuggestionsResponse.RebookingSuggestion = $root.lookupType('squareup.appointments.api.RebookingSuggestionsResponse.RebookingSuggestion');
fixType(RebookingSuggestionsResponse.RebookingSuggestion, {
  heading: {
    required: true
  },
  body: {
    required: true
  }
});
Builder.createAndAttachToType(RebookingSuggestionsResponse.RebookingSuggestion);
/**
 * SOURCE RebookingNotification @ squareup/appointments/api/external_service.proto at 1100:5
 */
RebookingSuggestionsResponse.RebookingSuggestion.RebookingNotification = $root.lookupType('squareup.appointments.api.RebookingSuggestionsResponse.RebookingSuggestion.RebookingNotification');
fixType(RebookingSuggestionsResponse.RebookingSuggestion.RebookingNotification);
Builder.createAndAttachToType(RebookingSuggestionsResponse.RebookingSuggestion.RebookingNotification);
/**
 * In future it might contain things like `optional bool supports_prepayment = 1;`
 *
 * SOURCE RebookingEligibilityRequest @ squareup/appointments/api/external_service.proto at 1118:1
 */
export const RebookingEligibilityRequest = $root.lookupType('squareup.appointments.api.RebookingEligibilityRequest');
fixType(RebookingEligibilityRequest, {
  occurrenceId: {
    required: true
  }
});
Builder.createAndAttachToType(RebookingEligibilityRequest);
/**
 * SOURCE RebookingEligibilityResponse @ squareup/appointments/api/external_service.proto at 1122:1
 */
export const RebookingEligibilityResponse = $root.lookupType('squareup.appointments.api.RebookingEligibilityResponse');
fixType(RebookingEligibilityResponse);
Builder.createAndAttachToType(RebookingEligibilityResponse);
/**
 * SOURCE OccurrenceCheckinRequest @ squareup/appointments/api/external_service.proto at 1133:1
 */
export const OccurrenceCheckinRequest = $root.lookupType('squareup.appointments.api.OccurrenceCheckinRequest');
fixType(OccurrenceCheckinRequest, {
  occurrenceId: {
    required: true
  }
});
Builder.createAndAttachToType(OccurrenceCheckinRequest);
/**
 * SOURCE OccurrenceCheckinResponse @ squareup/appointments/api/external_service.proto at 1138:1
 */
export const OccurrenceCheckinResponse = $root.lookupType('squareup.appointments.api.OccurrenceCheckinResponse');
fixType(OccurrenceCheckinResponse);
Builder.createAndAttachToType(OccurrenceCheckinResponse);
/**
 * SOURCE OccurrenceFeedbackRequest @ squareup/appointments/api/external_service.proto at 1146:1
 */
export const OccurrenceFeedbackRequest = $root.lookupType('squareup.appointments.api.OccurrenceFeedbackRequest');
fixType(OccurrenceFeedbackRequest, {
  occurrenceId: {
    required: true
  },
  rating: {
    required: true
  }
});
Builder.createAndAttachToType(OccurrenceFeedbackRequest);
/**
 * SOURCE OccurrenceFeedbackResponse @ squareup/appointments/api/external_service.proto at 1169:1
 */
export const OccurrenceFeedbackResponse = $root.lookupType('squareup.appointments.api.OccurrenceFeedbackResponse');
fixType(OccurrenceFeedbackResponse);
Builder.createAndAttachToType(OccurrenceFeedbackResponse);
/**
 * DEPRECATED: use `AttributedReview` instead.
 *
 * SOURCE OccurrenceFeedback @ squareup/appointments/api/external_service.proto at 1178:1
 */
export const OccurrenceFeedback = $root.lookupType('squareup.appointments.api.OccurrenceFeedback');
fixType(OccurrenceFeedback, {
  rating: {
    required: true
  }
});
Builder.createAndAttachToType(OccurrenceFeedback);
/**
 * SOURCE VariationDetails @ squareup/appointments/api/external_service.proto at 1191:3
 */
OccurrenceFeedback.VariationDetails = $root.lookupType('squareup.appointments.api.OccurrenceFeedback.VariationDetails');
fixType(OccurrenceFeedback.VariationDetails);
Builder.createAndAttachToType(OccurrenceFeedback.VariationDetails);
/**
 * Uploaded images will be deleted if they are never attached to a review.
 *
 * SOURCE UploadReviewImageRequest @ squareup/appointments/api/external_service.proto at 1213:1
 */
export const UploadReviewImageRequest = $root.lookupType('squareup.appointments.api.UploadReviewImageRequest');
fixType(UploadReviewImageRequest);
Builder.createAndAttachToType(UploadReviewImageRequest);
/**
 * SOURCE UploadReviewImageResponse @ squareup/appointments/api/external_service.proto at 1217:1
 */
export const UploadReviewImageResponse = $root.lookupType('squareup.appointments.api.UploadReviewImageResponse');
fixType(UploadReviewImageResponse);
Builder.createAndAttachToType(UploadReviewImageResponse);
/**
 * SOURCE Metadata @ squareup/appointments/api/external_service.proto at 1218:3
 */
UploadReviewImageResponse.Metadata = $root.lookupType('squareup.appointments.api.UploadReviewImageResponse.Metadata');
fixType(UploadReviewImageResponse.Metadata);
Builder.createAndAttachToType(UploadReviewImageResponse.Metadata);
/**
 * SOURCE GlobalBuyer @ squareup/appointments/api/external_service.proto at 1231:1
 */
export const GlobalBuyer = $root.lookupType('squareup.appointments.api.GlobalBuyer');
fixType(GlobalBuyer);
Builder.createAndAttachToType(GlobalBuyer);
/**
 * SOURCE Settings @ squareup/appointments/api/external_service.proto at 1252:3
 */
GlobalBuyer.Settings = $root.lookupType('squareup.appointments.api.GlobalBuyer.Settings');
fixType(GlobalBuyer.Settings);
Builder.createAndAttachToType(GlobalBuyer.Settings);
/**
 * SOURCE UpsertGlobalBuyerRequest @ squareup/appointments/api/external_service.proto at 1277:1
 */
export const UpsertGlobalBuyerRequest = $root.lookupType('squareup.appointments.api.UpsertGlobalBuyerRequest');
fixType(UpsertGlobalBuyerRequest);
Builder.createAndAttachToType(UpsertGlobalBuyerRequest);
/**
 * SOURCE UpsertGlobalBuyerResponse @ squareup/appointments/api/external_service.proto at 1286:1
 */
export const UpsertGlobalBuyerResponse = $root.lookupType('squareup.appointments.api.UpsertGlobalBuyerResponse');
fixType(UpsertGlobalBuyerResponse);
Builder.createAndAttachToType(UpsertGlobalBuyerResponse);
/**
 * SOURCE RetrieveGlobalBuyerRequest @ squareup/appointments/api/external_service.proto at 1293:1
 */
export const RetrieveGlobalBuyerRequest = $root.lookupType('squareup.appointments.api.RetrieveGlobalBuyerRequest');
fixType(RetrieveGlobalBuyerRequest);
Builder.createAndAttachToType(RetrieveGlobalBuyerRequest);
/**
 * SOURCE RetrieveGlobalBuyerResponse @ squareup/appointments/api/external_service.proto at 1300:1
 */
export const RetrieveGlobalBuyerResponse = $root.lookupType('squareup.appointments.api.RetrieveGlobalBuyerResponse');
fixType(RetrieveGlobalBuyerResponse);
Builder.createAndAttachToType(RetrieveGlobalBuyerResponse);
/**
 * SOURCE DeleteGlobalBuyerRequest @ squareup/appointments/api/external_service.proto at 1308:1
 */
export const DeleteGlobalBuyerRequest = $root.lookupType('squareup.appointments.api.DeleteGlobalBuyerRequest');
fixType(DeleteGlobalBuyerRequest);
Builder.createAndAttachToType(DeleteGlobalBuyerRequest);
/**
 * SOURCE DeleteGlobalBuyerResponse @ squareup/appointments/api/external_service.proto at 1312:1
 */
export const DeleteGlobalBuyerResponse = $root.lookupType('squareup.appointments.api.DeleteGlobalBuyerResponse');
fixType(DeleteGlobalBuyerResponse);
Builder.createAndAttachToType(DeleteGlobalBuyerResponse);
/**
 * SOURCE UpsertProfileImageRequest @ squareup/appointments/api/external_service.proto at 1317:1
 */
export const UpsertProfileImageRequest = $root.lookupType('squareup.appointments.api.UpsertProfileImageRequest');
fixType(UpsertProfileImageRequest);
Builder.createAndAttachToType(UpsertProfileImageRequest);
/**
 * SOURCE UpsertProfileImageResponse @ squareup/appointments/api/external_service.proto at 1322:1
 */
export const UpsertProfileImageResponse = $root.lookupType('squareup.appointments.api.UpsertProfileImageResponse');
fixType(UpsertProfileImageResponse);
Builder.createAndAttachToType(UpsertProfileImageResponse);
/**
 * SOURCE Occurrence @ squareup/appointments/api/external_service.proto at 1330:1
 */
export const Occurrence = $root.lookupType('squareup.appointments.api.Occurrence');
fixType(Occurrence);
Builder.createAndAttachToType(Occurrence);
/**
 * SOURCE BookedVariationDetail @ squareup/appointments/api/external_service.proto at 1348:3
 */
Occurrence.BookedVariationDetail = $root.lookupType('squareup.appointments.api.Occurrence.BookedVariationDetail');
fixType(Occurrence.BookedVariationDetail);
Builder.createAndAttachToType(Occurrence.BookedVariationDetail);
/**
 * SOURCE EmployeeDetail @ squareup/appointments/api/external_service.proto at 1407:1
 */
export const EmployeeDetail = $root.lookupType('squareup.appointments.api.EmployeeDetail');
fixType(EmployeeDetail);
Builder.createAndAttachToType(EmployeeDetail);
/**
 * SOURCE CancelOccurrenceRequest @ squareup/appointments/api/external_service.proto at 1432:1
 */
export const CancelOccurrenceRequest = $root.lookupType('squareup.appointments.api.CancelOccurrenceRequest');
fixType(CancelOccurrenceRequest);
Builder.createAndAttachToType(CancelOccurrenceRequest);
/**
 * SOURCE CancelOccurrenceResponse @ squareup/appointments/api/external_service.proto at 1436:1
 */
export const CancelOccurrenceResponse = $root.lookupType('squareup.appointments.api.CancelOccurrenceResponse');
fixType(CancelOccurrenceResponse);
Builder.createAndAttachToType(CancelOccurrenceResponse);
/**
 * SOURCE RescheduleOccurrenceRequest @ squareup/appointments/api/external_service.proto at 1448:1
 */
export const RescheduleOccurrenceRequest = $root.lookupType('squareup.appointments.api.RescheduleOccurrenceRequest');
fixType(RescheduleOccurrenceRequest, {
  bookingRequestToken: {
    required: true
  }
});
Builder.createAndAttachToType(RescheduleOccurrenceRequest);
/**
 * SOURCE RescheduleOccurrenceResponse @ squareup/appointments/api/external_service.proto at 1457:1
 */
export const RescheduleOccurrenceResponse = $root.lookupType('squareup.appointments.api.RescheduleOccurrenceResponse');
fixType(RescheduleOccurrenceResponse);
Builder.createAndAttachToType(RescheduleOccurrenceResponse);
/**
 * SOURCE RebookOccurrenceRequest @ squareup/appointments/api/external_service.proto at 1469:1
 */
export const RebookOccurrenceRequest = $root.lookupType('squareup.appointments.api.RebookOccurrenceRequest');
fixType(RebookOccurrenceRequest, {
  bookingRequestToken: {
    required: true
  }
});
Builder.createAndAttachToType(RebookOccurrenceRequest);
/**
 * SOURCE RebookOccurrenceResponse @ squareup/appointments/api/external_service.proto at 1475:1
 */
export const RebookOccurrenceResponse = $root.lookupType('squareup.appointments.api.RebookOccurrenceResponse');
fixType(RebookOccurrenceResponse);
Builder.createAndAttachToType(RebookOccurrenceResponse);
/**
 * SOURCE ConfirmOccurrenceRequest @ squareup/appointments/api/external_service.proto at 1483:1
 */
export const ConfirmOccurrenceRequest = $root.lookupType('squareup.appointments.api.ConfirmOccurrenceRequest');
fixType(ConfirmOccurrenceRequest);
Builder.createAndAttachToType(ConfirmOccurrenceRequest);
/**
 * SOURCE ConfirmOccurrenceResponse @ squareup/appointments/api/external_service.proto at 1487:1
 */
export const ConfirmOccurrenceResponse = $root.lookupType('squareup.appointments.api.ConfirmOccurrenceResponse');
fixType(ConfirmOccurrenceResponse);
Builder.createAndAttachToType(ConfirmOccurrenceResponse);
/**
 * SOURCE ListRecommendedUnitsRequest @ squareup/appointments/api/external_service.proto at 1496:1
 */
export const ListRecommendedUnitsRequest = $root.lookupType('squareup.appointments.api.ListRecommendedUnitsRequest');
fixType(ListRecommendedUnitsRequest);
Builder.createAndAttachToType(ListRecommendedUnitsRequest);
/**
 * SOURCE ListRecommendedUnitsResponse @ squareup/appointments/api/external_service.proto at 1500:1
 */
export const ListRecommendedUnitsResponse = $root.lookupType('squareup.appointments.api.ListRecommendedUnitsResponse');
fixType(ListRecommendedUnitsResponse);
Builder.createAndAttachToType(ListRecommendedUnitsResponse);
/**
 * SOURCE RecommendedUnit @ squareup/appointments/api/external_service.proto at 1501:3
 */
ListRecommendedUnitsResponse.RecommendedUnit = $root.lookupType('squareup.appointments.api.ListRecommendedUnitsResponse.RecommendedUnit');
fixType(ListRecommendedUnitsResponse.RecommendedUnit);
Builder.createAndAttachToType(ListRecommendedUnitsResponse.RecommendedUnit);
/**
 * SOURCE RetrieveMessengerPhoneNumberRequest @ squareup/appointments/api/external_service.proto at 1514:1
 */
export const RetrieveMessengerPhoneNumberRequest = $root.lookupType('squareup.appointments.api.RetrieveMessengerPhoneNumberRequest');
fixType(RetrieveMessengerPhoneNumberRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveMessengerPhoneNumberRequest);
/**
 * SOURCE RetrieveMessengerPhoneNumberResponse @ squareup/appointments/api/external_service.proto at 1518:1
 */
export const RetrieveMessengerPhoneNumberResponse = $root.lookupType('squareup.appointments.api.RetrieveMessengerPhoneNumberResponse');
fixType(RetrieveMessengerPhoneNumberResponse);
Builder.createAndAttachToType(RetrieveMessengerPhoneNumberResponse);
/**
 * SOURCE ValidateAccessCodeRequest @ squareup/appointments/api/external_service.proto at 1527:1
 */
export const ValidateAccessCodeRequest = $root.lookupType('squareup.appointments.api.ValidateAccessCodeRequest');
fixType(ValidateAccessCodeRequest, {
  accessCode: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ValidateAccessCodeRequest);
/**
 * SOURCE ValidateAccessCodeResponse @ squareup/appointments/api/external_service.proto at 1535:1
 */
export const ValidateAccessCodeResponse = $root.lookupType('squareup.appointments.api.ValidateAccessCodeResponse');
fixType(ValidateAccessCodeResponse);
Builder.createAndAttachToType(ValidateAccessCodeResponse);
/**
 * Check is based on current multipass session. Will error without a session.
 *
 * SOURCE MarketplaceAppAccessRequest @ squareup/appointments/api/external_service.proto at 1547:1
 */
export const MarketplaceAppAccessRequest = $root.lookupType('squareup.appointments.api.MarketplaceAppAccessRequest');
fixType(MarketplaceAppAccessRequest);
Builder.createAndAttachToType(MarketplaceAppAccessRequest);
/**
 * SOURCE MarketplaceAppAccessResponse @ squareup/appointments/api/external_service.proto at 1552:1
 */
export const MarketplaceAppAccessResponse = $root.lookupType('squareup.appointments.api.MarketplaceAppAccessResponse');
fixType(MarketplaceAppAccessResponse);
Builder.createAndAttachToType(MarketplaceAppAccessResponse);
/**
 * SOURCE CreateMarketplaceInviteListEntryRequest @ squareup/appointments/api/external_service.proto at 1562:1
 */
export const CreateMarketplaceInviteListEntryRequest = $root.lookupType('squareup.appointments.api.CreateMarketplaceInviteListEntryRequest');
fixType(CreateMarketplaceInviteListEntryRequest, {
  phone: {
    required: true
  },
  zipcode: {
    required: true
  }
});
Builder.createAndAttachToType(CreateMarketplaceInviteListEntryRequest);
/**
 * SOURCE CreateMarketplaceInviteListEntryResponse @ squareup/appointments/api/external_service.proto at 1573:1
 */
export const CreateMarketplaceInviteListEntryResponse = $root.lookupType('squareup.appointments.api.CreateMarketplaceInviteListEntryResponse');
fixType(CreateMarketplaceInviteListEntryResponse);
Builder.createAndAttachToType(CreateMarketplaceInviteListEntryResponse);
/**
 * SOURCE Paywall @ squareup/appointments/api/external_service.proto at 1578:1
 */
export const Paywall = $root.lookupEnum('squareup.appointments.api.Paywall').values;
/**
 * Copied from sub2.data.Feature, you can't extend enums
 *
 * SOURCE SubscriptionFeature @ squareup/appointments/api/external_service.proto at 1592:1
 */
export const SubscriptionFeature = $root.lookupEnum('squareup.appointments.api.SubscriptionFeature').values;
/**
 * SOURCE GetSubscriptionRequest @ squareup/appointments/api/external_service.proto at 1696:1
 */
export const GetSubscriptionRequest = $root.lookupType('squareup.appointments.api.GetSubscriptionRequest');
fixType(GetSubscriptionRequest);
Builder.createAndAttachToType(GetSubscriptionRequest);
/**
 * SOURCE GetSubscriptionResponse @ squareup/appointments/api/external_service.proto at 1700:1
 */
export const GetSubscriptionResponse = $root.lookupType('squareup.appointments.api.GetSubscriptionResponse');
fixType(GetSubscriptionResponse);
Builder.createAndAttachToType(GetSubscriptionResponse);
/**
 * SOURCE SubscriptionMigrationState @ squareup/appointments/api/external_service.proto at 1701:3
 */
GetSubscriptionResponse.SubscriptionMigrationState = $root.lookupEnum('squareup.appointments.api.GetSubscriptionResponse.SubscriptionMigrationState').values;
/**
 * SOURCE UpdateSubscriptionRequest @ squareup/appointments/api/external_service.proto at 1715:1
 */
export const UpdateSubscriptionRequest = $root.lookupType('squareup.appointments.api.UpdateSubscriptionRequest');
fixType(UpdateSubscriptionRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  planToken: {
    notEmpty: true
  },
  subscribedLocations: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateSubscriptionRequest);
/**
 * SOURCE UpdateSubscriptionResponse @ squareup/appointments/api/external_service.proto at 1723:1
 */
export const UpdateSubscriptionResponse = $root.lookupType('squareup.appointments.api.UpdateSubscriptionResponse');
fixType(UpdateSubscriptionResponse);
Builder.createAndAttachToType(UpdateSubscriptionResponse);
/**
 * SOURCE AcknowledgeSubscriptionRequest @ squareup/appointments/api/external_service.proto at 1731:1
 */
export const AcknowledgeSubscriptionRequest = $root.lookupType('squareup.appointments.api.AcknowledgeSubscriptionRequest');
fixType(AcknowledgeSubscriptionRequest);
Builder.createAndAttachToType(AcknowledgeSubscriptionRequest);
/**
 * SOURCE AcknowledgeSubscriptionResponse @ squareup/appointments/api/external_service.proto at 1733:1
 */
export const AcknowledgeSubscriptionResponse = $root.lookupType('squareup.appointments.api.AcknowledgeSubscriptionResponse');
fixType(AcknowledgeSubscriptionResponse);
Builder.createAndAttachToType(AcknowledgeSubscriptionResponse);
/**
 * SOURCE ClassSchedule @ squareup/appointments/api/external_service.proto at 1735:1
 */
export const ClassSchedule = $root.lookupType('squareup.appointments.api.ClassSchedule');
fixType(ClassSchedule);
Builder.createAndAttachToType(ClassSchedule);
/**
 * SOURCE ClassScheduleStatus @ squareup/appointments/api/external_service.proto at 1792:1
 */
export const ClassScheduleStatus = $root.lookupEnum('squareup.appointments.api.ClassScheduleStatus').values;
/**
 * SOURCE ClassBooking @ squareup/appointments/api/external_service.proto at 1803:1
 */
export const ClassBooking = $root.lookupType('squareup.appointments.api.ClassBooking');
fixType(ClassBooking, {
  classScheduleId: {
    notEmpty: true
  },
  customerId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ClassBooking);
/**
 * SOURCE ClassBookingStatus @ squareup/appointments/api/external_service.proto at 1827:1
 */
export const ClassBookingStatus = $root.lookupEnum('squareup.appointments.api.ClassBookingStatus').values;
/**
 * SOURCE ClassScheduleInstance @ squareup/appointments/api/external_service.proto at 1847:1
 */
export const ClassScheduleInstance = $root.lookupType('squareup.appointments.api.ClassScheduleInstance');
fixType(ClassScheduleInstance, {
  classScheduleId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ClassScheduleInstance);
/**
 * SOURCE SearchClassScheduleInstancesRequest @ squareup/appointments/api/external_service.proto at 1868:1
 */
export const SearchClassScheduleInstancesRequest = $root.lookupType('squareup.appointments.api.SearchClassScheduleInstancesRequest');
fixType(SearchClassScheduleInstancesRequest, {
  query: {
    required: true
  }
});
Builder.createAndAttachToType(SearchClassScheduleInstancesRequest);
/**
 * SOURCE ClassesResource @ squareup/appointments/api/external_service.proto at 1888:1
 */
export const ClassesResource = $root.lookupEnum('squareup.appointments.api.ClassesResource').values;
/**
 * SOURCE ClassScheduleInstanceSort @ squareup/appointments/api/external_service.proto at 1895:1
 */
export const ClassScheduleInstanceSort = $root.lookupType('squareup.appointments.api.ClassScheduleInstanceSort');
fixType(ClassScheduleInstanceSort);
Builder.createAndAttachToType(ClassScheduleInstanceSort);
/**
 * SOURCE ClassScheduleInstanceSortField @ squareup/appointments/api/external_service.proto at 1900:1
 */
export const ClassScheduleInstanceSortField = $root.lookupEnum('squareup.appointments.api.ClassScheduleInstanceSortField').values;
/**
 * SOURCE SearchClassScheduleInstancesQuery @ squareup/appointments/api/external_service.proto at 1906:1
 */
export const SearchClassScheduleInstancesQuery = $root.lookupType('squareup.appointments.api.SearchClassScheduleInstancesQuery');
fixType(SearchClassScheduleInstancesQuery, {
  filter: {
    required: true
  }
});
Builder.createAndAttachToType(SearchClassScheduleInstancesQuery);
/**
 * SOURCE SearchClassScheduleInstancesFilter @ squareup/appointments/api/external_service.proto at 1910:1
 */
export const SearchClassScheduleInstancesFilter = $root.lookupType('squareup.appointments.api.SearchClassScheduleInstancesFilter');
fixType(SearchClassScheduleInstancesFilter, {
  locationId: {
    required: true
  }
});
Builder.createAndAttachToType(SearchClassScheduleInstancesFilter);
/**
 * SOURCE SearchClassScheduleInstancesResponse @ squareup/appointments/api/external_service.proto at 1931:1
 */
export const SearchClassScheduleInstancesResponse = $root.lookupType('squareup.appointments.api.SearchClassScheduleInstancesResponse');
fixType(SearchClassScheduleInstancesResponse);
Builder.createAndAttachToType(SearchClassScheduleInstancesResponse);
/**
 * SOURCE ClassesIncludedResources @ squareup/appointments/api/external_service.proto at 1944:1
 */
export const ClassesIncludedResources = $root.lookupType('squareup.appointments.api.ClassesIncludedResources');
fixType(ClassesIncludedResources);
Builder.createAndAttachToType(ClassesIncludedResources);
/**
 * Retired, use SearchClassSchedules instead
 *
 * SOURCE ListClassSchedulesRequest @ squareup/appointments/api/external_service.proto at 1949:1
 */
export const ListClassSchedulesRequest = $root.lookupType('squareup.appointments.api.ListClassSchedulesRequest');
fixType(ListClassSchedulesRequest);
Builder.createAndAttachToType(ListClassSchedulesRequest);
/**
 * Retired, use SearchClassSchedules instead
 *
 * SOURCE ListClassSchedulesResponse @ squareup/appointments/api/external_service.proto at 1976:1
 */
export const ListClassSchedulesResponse = $root.lookupType('squareup.appointments.api.ListClassSchedulesResponse');
fixType(ListClassSchedulesResponse);
Builder.createAndAttachToType(ListClassSchedulesResponse);
/**
 * SOURCE SearchClassSchedulesRequest @ squareup/appointments/api/external_service.proto at 1987:1
 */
export const SearchClassSchedulesRequest = $root.lookupType('squareup.appointments.api.SearchClassSchedulesRequest');
fixType(SearchClassSchedulesRequest, {
  query: {
    required: true
  }
});
Builder.createAndAttachToType(SearchClassSchedulesRequest);
/**
 * SOURCE SearchClassSchedulesQuery @ squareup/appointments/api/external_service.proto at 2000:1
 */
export const SearchClassSchedulesQuery = $root.lookupType('squareup.appointments.api.SearchClassSchedulesQuery');
fixType(SearchClassSchedulesQuery, {
  filter: {
    required: true
  }
});
Builder.createAndAttachToType(SearchClassSchedulesQuery);
/**
 * SOURCE SearchClassSchedulesFilter @ squareup/appointments/api/external_service.proto at 2004:1
 */
export const SearchClassSchedulesFilter = $root.lookupType('squareup.appointments.api.SearchClassSchedulesFilter');
fixType(SearchClassSchedulesFilter, {
  locationId: {
    required: true
  }
});
Builder.createAndAttachToType(SearchClassSchedulesFilter);
/**
 * SOURCE SearchClassSchedulesResponse @ squareup/appointments/api/external_service.proto at 2016:1
 */
export const SearchClassSchedulesResponse = $root.lookupType('squareup.appointments.api.SearchClassSchedulesResponse');
fixType(SearchClassSchedulesResponse);
Builder.createAndAttachToType(SearchClassSchedulesResponse);
/**
 * SOURCE RetrieveClassScheduleRequest @ squareup/appointments/api/external_service.proto at 2027:1
 */
export const RetrieveClassScheduleRequest = $root.lookupType('squareup.appointments.api.RetrieveClassScheduleRequest');
fixType(RetrieveClassScheduleRequest, {
  classScheduleId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveClassScheduleRequest);
/**
 * SOURCE RetrieveClassScheduleResponse @ squareup/appointments/api/external_service.proto at 2035:1
 */
export const RetrieveClassScheduleResponse = $root.lookupType('squareup.appointments.api.RetrieveClassScheduleResponse');
fixType(RetrieveClassScheduleResponse);
Builder.createAndAttachToType(RetrieveClassScheduleResponse);
/**
 * SOURCE CreateClassScheduleRequest @ squareup/appointments/api/external_service.proto at 2043:1
 */
export const CreateClassScheduleRequest = $root.lookupType('squareup.appointments.api.CreateClassScheduleRequest');
fixType(CreateClassScheduleRequest, {
  classSchedule: {
    required: true
  }
});
Builder.createAndAttachToType(CreateClassScheduleRequest);
/**
 * SOURCE CreateClassScheduleResponse @ squareup/appointments/api/external_service.proto at 2051:1
 */
export const CreateClassScheduleResponse = $root.lookupType('squareup.appointments.api.CreateClassScheduleResponse');
fixType(CreateClassScheduleResponse);
Builder.createAndAttachToType(CreateClassScheduleResponse);
/**
 * SOURCE UpdateClassScheduleRequest @ squareup/appointments/api/external_service.proto at 2059:1
 */
export const UpdateClassScheduleRequest = $root.lookupType('squareup.appointments.api.UpdateClassScheduleRequest');
fixType(UpdateClassScheduleRequest, {
  classScheduleId: {
    notEmpty: true
  },
  classSchedule: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateClassScheduleRequest);
/**
 * SOURCE ClassScheduleUpdateType @ squareup/appointments/api/external_service.proto at 2091:1
 */
export const ClassScheduleUpdateType = $root.lookupEnum('squareup.appointments.api.ClassScheduleUpdateType').values;
/**
 * SOURCE UpdateClassScheduleResponse @ squareup/appointments/api/external_service.proto at 2105:1
 */
export const UpdateClassScheduleResponse = $root.lookupType('squareup.appointments.api.UpdateClassScheduleResponse');
fixType(UpdateClassScheduleResponse);
Builder.createAndAttachToType(UpdateClassScheduleResponse);
/**
 * SOURCE CancelClassScheduleRequest @ squareup/appointments/api/external_service.proto at 2117:1
 */
export const CancelClassScheduleRequest = $root.lookupType('squareup.appointments.api.CancelClassScheduleRequest');
fixType(CancelClassScheduleRequest, {
  classScheduleId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CancelClassScheduleRequest);
/**
 * SOURCE CancelClassScheduleResponse @ squareup/appointments/api/external_service.proto at 2133:1
 */
export const CancelClassScheduleResponse = $root.lookupType('squareup.appointments.api.CancelClassScheduleResponse');
fixType(CancelClassScheduleResponse);
Builder.createAndAttachToType(CancelClassScheduleResponse);
/**
 * Retired, use SearchClassBookings instead
 *
 * SOURCE ListClassBookingsRequest @ squareup/appointments/api/external_service.proto at 2142:1
 */
export const ListClassBookingsRequest = $root.lookupType('squareup.appointments.api.ListClassBookingsRequest');
fixType(ListClassBookingsRequest);
Builder.createAndAttachToType(ListClassBookingsRequest);
/**
 * Retired, use SearchClassBookings instead
 *
 * SOURCE ListClassBookingsResponse @ squareup/appointments/api/external_service.proto at 2171:1
 */
export const ListClassBookingsResponse = $root.lookupType('squareup.appointments.api.ListClassBookingsResponse');
fixType(ListClassBookingsResponse);
Builder.createAndAttachToType(ListClassBookingsResponse);
/**
 * SOURCE SearchClassBookingsRequest @ squareup/appointments/api/external_service.proto at 2182:1
 */
export const SearchClassBookingsRequest = $root.lookupType('squareup.appointments.api.SearchClassBookingsRequest');
fixType(SearchClassBookingsRequest);
Builder.createAndAttachToType(SearchClassBookingsRequest);
/**
 * SOURCE ClassBookingResource @ squareup/appointments/api/external_service.proto at 2183:3
 */
SearchClassBookingsRequest.ClassBookingResource = $root.lookupEnum('squareup.appointments.api.SearchClassBookingsRequest.ClassBookingResource').values;
/**
 * SOURCE SearchClassBookingsQuery @ squareup/appointments/api/external_service.proto at 2203:1
 */
export const SearchClassBookingsQuery = $root.lookupType('squareup.appointments.api.SearchClassBookingsQuery');
fixType(SearchClassBookingsQuery);
Builder.createAndAttachToType(SearchClassBookingsQuery);
/**
 * SOURCE SearchClassBookingsFilter @ squareup/appointments/api/external_service.proto at 2208:1
 */
export const SearchClassBookingsFilter = $root.lookupType('squareup.appointments.api.SearchClassBookingsFilter');
fixType(SearchClassBookingsFilter);
Builder.createAndAttachToType(SearchClassBookingsFilter);
/**
 * SOURCE ClassBookingsSort @ squareup/appointments/api/external_service.proto at 2230:1
 */
export const ClassBookingsSort = $root.lookupType('squareup.appointments.api.ClassBookingsSort');
fixType(ClassBookingsSort);
Builder.createAndAttachToType(ClassBookingsSort);
/**
 * SOURCE ClassBookingsSortField @ squareup/appointments/api/external_service.proto at 2231:3
 */
ClassBookingsSort.ClassBookingsSortField = $root.lookupEnum('squareup.appointments.api.ClassBookingsSort.ClassBookingsSortField').values;
/**
 * SOURCE SearchClassBookingsResponse @ squareup/appointments/api/external_service.proto at 2240:1
 */
export const SearchClassBookingsResponse = $root.lookupType('squareup.appointments.api.SearchClassBookingsResponse');
fixType(SearchClassBookingsResponse);
Builder.createAndAttachToType(SearchClassBookingsResponse);
/**
 * SOURCE ClassBookingIncludedResources @ squareup/appointments/api/external_service.proto at 2253:1
 */
export const ClassBookingIncludedResources = $root.lookupType('squareup.appointments.api.ClassBookingIncludedResources');
fixType(ClassBookingIncludedResources);
Builder.createAndAttachToType(ClassBookingIncludedResources);
/**
 * SOURCE RetrieveClassBookingRequest @ squareup/appointments/api/external_service.proto at 2257:1
 */
export const RetrieveClassBookingRequest = $root.lookupType('squareup.appointments.api.RetrieveClassBookingRequest');
fixType(RetrieveClassBookingRequest, {
  classBookingId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveClassBookingRequest);
/**
 * SOURCE RetrieveClassBookingResponse @ squareup/appointments/api/external_service.proto at 2262:1
 */
export const RetrieveClassBookingResponse = $root.lookupType('squareup.appointments.api.RetrieveClassBookingResponse');
fixType(RetrieveClassBookingResponse);
Builder.createAndAttachToType(RetrieveClassBookingResponse);
/**
 * SOURCE CreateClassBookingRequest @ squareup/appointments/api/external_service.proto at 2270:1
 */
export const CreateClassBookingRequest = $root.lookupType('squareup.appointments.api.CreateClassBookingRequest');
fixType(CreateClassBookingRequest, {
  classBooking: {
    required: true
  }
});
Builder.createAndAttachToType(CreateClassBookingRequest);
/**
 * SOURCE CreateClassBookingResponse @ squareup/appointments/api/external_service.proto at 2281:1
 */
export const CreateClassBookingResponse = $root.lookupType('squareup.appointments.api.CreateClassBookingResponse');
fixType(CreateClassBookingResponse);
Builder.createAndAttachToType(CreateClassBookingResponse);
/**
 * SOURCE UpdateClassBookingRequest @ squareup/appointments/api/external_service.proto at 2289:1
 */
export const UpdateClassBookingRequest = $root.lookupType('squareup.appointments.api.UpdateClassBookingRequest');
fixType(UpdateClassBookingRequest, {
  classBooking: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateClassBookingRequest);
/**
 * SOURCE UpdateClassBookingResponse @ squareup/appointments/api/external_service.proto at 2297:1
 */
export const UpdateClassBookingResponse = $root.lookupType('squareup.appointments.api.UpdateClassBookingResponse');
fixType(UpdateClassBookingResponse);
Builder.createAndAttachToType(UpdateClassBookingResponse);
/**
 * SOURCE CancelClassBookingRequest @ squareup/appointments/api/external_service.proto at 2305:1
 */
export const CancelClassBookingRequest = $root.lookupType('squareup.appointments.api.CancelClassBookingRequest');
fixType(CancelClassBookingRequest, {
  classBookingId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CancelClassBookingRequest);
/**
 * SOURCE CancelClassBookingResponse @ squareup/appointments/api/external_service.proto at 2315:1
 */
export const CancelClassBookingResponse = $root.lookupType('squareup.appointments.api.CancelClassBookingResponse');
fixType(CancelClassBookingResponse);
Builder.createAndAttachToType(CancelClassBookingResponse);
/**
 * SOURCE CompleteClassBookingRequest @ squareup/appointments/api/external_service.proto at 2323:1
 */
export const CompleteClassBookingRequest = $root.lookupType('squareup.appointments.api.CompleteClassBookingRequest');
fixType(CompleteClassBookingRequest, {
  classBooking: {
    required: true
  }
});
Builder.createAndAttachToType(CompleteClassBookingRequest);
/**
 * SOURCE CompleteClassBookingResponse @ squareup/appointments/api/external_service.proto at 2344:1
 */
export const CompleteClassBookingResponse = $root.lookupType('squareup.appointments.api.CompleteClassBookingResponse');
fixType(CompleteClassBookingResponse);
Builder.createAndAttachToType(CompleteClassBookingResponse);
/**
 * SOURCE PayClassBookingRequest @ squareup/appointments/api/external_service.proto at 2352:1
 */
export const PayClassBookingRequest = $root.lookupType('squareup.appointments.api.PayClassBookingRequest');
fixType(PayClassBookingRequest, {
  classBookingId: {
    required: true
  }
});
Builder.createAndAttachToType(PayClassBookingRequest);
/**
 * SOURCE PayClassBookingResponse @ squareup/appointments/api/external_service.proto at 2366:1
 */
export const PayClassBookingResponse = $root.lookupType('squareup.appointments.api.PayClassBookingResponse');
fixType(PayClassBookingResponse);
Builder.createAndAttachToType(PayClassBookingResponse);
/**
 * SOURCE RetrieveClassesProfileRequest @ squareup/appointments/api/external_service.proto at 2374:1
 */
export const RetrieveClassesProfileRequest = $root.lookupType('squareup.appointments.api.RetrieveClassesProfileRequest');
fixType(RetrieveClassesProfileRequest);
Builder.createAndAttachToType(RetrieveClassesProfileRequest);
/**
 * SOURCE RetrieveClassesProfileResponse @ squareup/appointments/api/external_service.proto at 2376:1
 */
export const RetrieveClassesProfileResponse = $root.lookupType('squareup.appointments.api.RetrieveClassesProfileResponse');
fixType(RetrieveClassesProfileResponse);
Builder.createAndAttachToType(RetrieveClassesProfileResponse);
/**
 * SOURCE EnableCustomerBlockingRequest @ squareup/appointments/api/external_service.proto at 2393:1
 */
export const EnableCustomerBlockingRequest = $root.lookupType('squareup.appointments.api.EnableCustomerBlockingRequest');
fixType(EnableCustomerBlockingRequest);
Builder.createAndAttachToType(EnableCustomerBlockingRequest);
/**
 * SOURCE EnableCustomerBlockingResponse @ squareup/appointments/api/external_service.proto at 2398:1
 */
export const EnableCustomerBlockingResponse = $root.lookupType('squareup.appointments.api.EnableCustomerBlockingResponse');
fixType(EnableCustomerBlockingResponse);
Builder.createAndAttachToType(EnableCustomerBlockingResponse);
/**
 * SOURCE ValidateAposDataResponse @ squareup/appointments/api/external_service.proto at 2407:1
 */
export const ValidateAposDataResponse = $root.lookupType('squareup.appointments.api.ValidateAposDataResponse');
fixType(ValidateAposDataResponse);
Builder.createAndAttachToType(ValidateAposDataResponse);
/**
 * SOURCE ExternalAppointmentsService @ squareup/appointments/api/external_service.proto at 2413:1
 */
export const ExternalAppointmentsService = $root.lookupService('squareup.appointments.api.ExternalAppointmentsService');